export default {
  // Danh sách thành viên mất khách hàng
  'memberChurn.title': 'Danh sách thành viên mất khách hàng',
  'memberChurn.vipLevels': 'Cấp VIP',
  'memberChurn.caliberDescription': 'Mô tả tiêu chuẩn',
  'memberChurn.search': 'Tìm kiếm',
  'memberChurn.reset': 'Đặt lại',
  'memberChurn.export': 'Xuất',
  'memberChurn.memberAccount': 'Tài khoản thành viên',
  'memberChurn.realName': 'Tên thực của thành viên',
  'memberChurn.memberName': 'Biệt danh thành viên',
  'memberChurn.agentAccount': 'Tài khoản đại lý cấp trên',
  'memberChurn.registerInfo': 'Thông tin đăng ký',
  'memberChurn.registerTime': 'Thời gian đăng ký',
  'memberChurn.registerIp': 'IP đăng ký',
  'memberChurn.rechargeCount': 'Số lần nạp',
  'memberChurn.withdrawCount': 'Số lần rút',
  'memberChurn.totalRecharge': 'Tổng nạp (Đa tiền tệ)',
  'memberChurn.totalWithdraw': 'Tổng rút',
  'memberChurn.firstRechargeTime': 'Thời gian nạp đầu',
  'memberChurn.lastRechargeTime': 'Thời gian nạp gần nhất',
  'memberChurn.lastRechargeStartTime': 'Thời gian nạp gần nhất (Bắt đầu)',
  'memberChurn.lastRechargeEndTime': 'Thời gian nạp gần nhất (Kết thúc)',
'memberChurn.lastLoginTime': 'Thời gian đăng nhập gần nhất',
'memberChurn.lastBettingTime': 'Thời gian cược gần nhất',
  'memberChurn.action': 'Thao tác',
  'memberChurn.view': 'Xem',
  'memberChurn.noData': 'Không có dữ liệu',
  'memberChurn.defaultEmpty': 'Vui lòng chọn điều kiện tìm kiếm',
  'memberChurn.requestFailed': 'Yêu cầu thất bại',
  'memberChurn.export.loading': 'Đang xuất dữ liệu...',
  'memberChurn.export.success': 'Xuất thành công',
  'memberChurn.export.failed': 'Xuất thất bại',
  'memberChurn.timeRangeWarning': 'Vui lòng chọn khoảng thời gian',
  'memberChurn.startTime': 'Thời gian nạp tiền gần nhất (Bắt đầu)',
  'memberChurn.endTime': 'Thời gian nạp tiền gần nhất (Kết thúc)',
  'memberChurn.timeRangeError': 'Thời gian bắt đầu không thể muộn hơn thời gian kết thúc',
  'memberChurn.depositTimeQueryTip': '[Khuyến nghị chọn thời gian nạp tiền gần nhất để truy vấn trước]',
  'memberChurn.caliberTooltip': 'Tiêu chuẩn mất khách hàng: Chỉ đánh giá theo nạp tiền. Lọc người dùng có "lần nạp thành công gần nhất rơi vào khoảng thời gian đã chọn và không có nạp mới kể từ đó"; Hiển thị mặc định: Người dùng không nạp trong 3 ngày (thời gian kết thúc = hôm nay - 3 ngày, thời gian bắt đầu để trống); Cách sử dụng phổ biến: Chỉ điền "thời gian kết thúc" → Tìm người dùng có "nạp gần nhất ≤ ngày đó và không có nạp mới cho đến nay"; Điền cả "bắt đầu + kết thúc" → Tìm người dùng có "nạp gần nhất trong khoảng và không có nạp mới cho đến nay"; Chỉ điền "thời gian bắt đầu" → Tìm người dùng có "nạp gần nhất ≥ ngày đó và không có nạp mới cho đến nay"; Ví dụ: Hôm nay 8/27, chọn thời gian kết thúc 8/24 → Lọc người dùng có nạp gần nhất vào hoặc trước 8/24 và không có nạp từ 8/25–8/27. Chọn khoảng thời gian 8/1–8/7 → Lọc người dùng có nạp gần nhất giữa 8/1–8/7 và không có nạp từ 8/8–8/27. Lưu ý: Đăng nhập/đặt cược không ảnh hưởng đến đánh giá mất khách hàng.',
  'member.detail.search.memberAccount': 'Tài khoản thành viên',
  'member.detail.search.placeholder': 'Vui lòng nhập tài khoản thành viên / số điện thoại / email',
  'member.detail.search.button': 'Tìm kiếm',
  'member.detail.search.refresh': 'Làm mới',
  'member.detail.search.notFound': 'Không tìm thấy thông tin thành viên',
  'member.detail.search.error': 'Lỗi dịch vụ',
  'member.detail.tabs.basicInfo': 'Thông tin cơ bản',
  'member.detail.tabs.accountInfo': 'Thông tin tài khoản',
  'member.detail.tabs.mainAccountTrade': 'Giao dịch tài khoản chính',
  'member.detail.tabs.recentBets': 'Cược 7 ngày gần nhất',
  'member.detail.tabs.promotionInfo': 'Thông tin ưu đãi',
  'member.detail.tabs.memberPoints': 'Điểm thành viên',
  'member.detail.tabs.gameAccountTrade': 'Giao dịch tài khoản game',
  'member.detail.tabs.riskControl': 'Thông tin kiểm soát rủi ro',
  'member.detail.tabs.badDebt': 'Hồ sơ nợ xấu',
  'member.detail.tabs.regulatoryReport': 'Trạng thái tuyến game',
  'member.detail.regulatoryReport.statusLabel': 'Trạng thái',
  'member.detail.regulatoryReport.statusReporting': 'Đang báo cáo',
  'member.detail.regulatoryReport.statusClosed': 'Đã tắt báo cáo',
  'member.detail.regulatoryReport.closeButton': 'Tắt gửi dữ liệu',
  'member.detail.regulatoryReport.closeButtonHint': 'Nhấn để kiểm tra điều kiện tiên quyết theo thời gian thực',
  'member.detail.regulatoryReport.precheckTitle': 'Kiểm tra trước khi tắt báo cáo',
  'member.detail.regulatoryReport.precheckBanner': 'Hệ thống phát hiện các vấn đề sau, không thể thực hiện thao tác đóng:',
  'member.detail.regulatoryReport.precheckOk': 'Đã hiểu, thử lại sau',
  'member.detail.regulatoryReport.check.deposit.ok': 'Không có lệnh nạp chờ thanh toán',
  'member.detail.regulatoryReport.check.deposit.fail': 'Người dùng có lệnh nạp chờ thanh toán, vui lòng thử lại sau',
  'member.detail.regulatoryReport.check.withdraw.ok': 'Không có lệnh rút tiền chờ chi',
  'member.detail.regulatoryReport.check.withdraw.fail': 'Người dùng có lệnh rút tiền chờ chi, vui lòng thử lại sau',
  'member.detail.regulatoryReport.check.unsettledBet.ok': 'Không có cược chờ quyết toán',
  'member.detail.regulatoryReport.check.unsettledBet.fail': 'Người dùng có cược chờ quyết toán, vui lòng thử lại sau',
  'member.detail.regulatoryReport.check.recentBet.ok': 'Không có hành vi chơi đang diễn ra (10 phút gần nhất không có cược)',
  'member.detail.regulatoryReport.check.recentBet.fail': 'Người dùng có cược trong 10 phút gần nhất, vui lòng thử lại sau',
  'member.detail.regulatoryReport.ordersDetail': 'Mã lệnh: {orders}',
  'member.detail.regulatoryReport.reasonTitle': 'Lý do tắt báo cáo',
  'member.detail.regulatoryReport.reasonPlaceholder': 'Nhập lý do thao tác',
  'member.detail.regulatoryReport.reasonRequired': 'Vui lòng nhập lý do',
  'member.detail.regulatoryReport.confirmClose': 'Xác nhận tắt',
  'member.detail.regulatoryReport.applySuccess': 'Đã tắt gửi dữ liệu',
  'member.detail.regulatoryReport.applyFail': 'Tắt thất bại',
  'member.detail.regulatoryReport.precheckFail': 'Kiểm tra trước thất bại',

  'member.closeReportUser.title': 'Nhật ký thay đổi tuyến game',
  'member.closeReportUser.subtitle': 'Chỉ hiển thị người dùng đã tắt báo cáo dữ liệu PAGCOR; hỗ trợ xuất.',
  'member.closeReportUser.memberAccount': 'Tài khoản hội viên',
  'member.closeReportUser.memberAccountPh': 'Tài khoản hội viên',
  'member.closeReportUser.closeTimeRange': 'Thời gian tắt báo cáo',
  'member.closeReportUser.closeTime': 'Thời gian tắt báo cáo',
  'member.closeReportUser.operatorName': 'Người thao tác',
  'member.closeReportUser.operatorPh': 'Tài khoản người thao tác',
  'member.closeReportUser.operationReason': 'Lý do thao tác',

  'member.reportStatus.detail.title': 'Trạng thái báo cáo',
  'member.reportStatus.detail.currentTitle': 'Trạng thái hiện tại',
  'member.reportStatus.detail.currentStatus': 'report_status hiện tại',
  'member.reportStatus.detail.latestSwitch': 'Lần chuyển gần nhất',
  'member.reportStatus.detail.switchReason': 'Lý do chuyển',
  'member.reportStatus.detail.toggleBtn': 'Chuyển tuyến game',
  'member.reportStatus.detail.historyTitle': 'Lịch sử chuyển',
  'member.reportStatus.col.time': 'Thời gian',
  'member.reportStatus.col.type': 'Loại',
  'member.reportStatus.col.statusChange': 'Thay đổi trạng thái',
  'member.reportStatus.col.operator': 'Người thao tác',
  'member.reportStatus.col.reason': 'Lý do',
  'member.reportStatus.col.remark': 'Ghi chú',
  'member.reportStatus.status.reported': 'Tuyến A',
  'member.reportStatus.status.notReported': 'Tuyến B',
  'member.reportStatus.type.registerAuto': 'Tự động (Đăng ký)',
  'member.reportStatus.type.manual': 'Thủ công',
  'member.reportStatus.type.autoThreshold': 'Đạt nạp',
  'member.reportStatus.type.autoVip': 'Đạt VIP',
  'member.reportStatus.reasonLabel.REGISTER_AUTO': 'Gắn nhãn theo tỷ lệ khi đăng ký',
  'member.reportStatus.reasonLabel.AUTO_THRESHOLD': 'Đạt ngưỡng nạp tích lũy',
  'member.reportStatus.reasonLabel.AUTO_VIP': 'Đạt cấp VIP',
  'member.reportStatus.modal.title': 'Chuyển tuyến game',
  'member.reportStatus.modal.memberAccount': 'Tài khoản hội viên',
  'member.reportStatus.modal.statusChange': 'Thay đổi trạng thái',
  'member.reportStatus.modal.reason': 'Lý do chuyển',
  'member.reportStatus.modal.remark': 'Ghi chú',
  'member.reportStatus.modal.remarkPh': 'Có thể ghi lý do chi tiết để phục vụ kiểm toán',
  'member.reportStatus.modal.reasonPh': 'Bắt buộc. Vui lòng nêu lý do chuyển (VD: tài khoản test nội bộ / thu hồi tài khoản / user tiếp nhận nhầm / user đặc cách, v.v.)',
  'member.reportStatus.modal.confirm': 'Xác nhận',
  'member.reportStatus.modal.cancel': 'Hủy',
  'member.reportStatus.modal.reasonRequired': 'Vui lòng chọn lý do chuyển',
  'member.reportStatus.modal.backupTip': 'Sau khi chuyển, hệ thống sẽ sao lưu bet_record hiện tại của người dùng sang bet_record_bak (phục vụ kiểm toán). Có hiệu lực từ ván game tiếp theo.',
  'member.reportStatus.reason.arbitrage': 'Xác nhận tài khoản arbitrage',
  'member.reportStatus.reason.channel': 'Xung đột quy thuộc kênh',
  'member.reportStatus.reason.internal': 'Tài khoản test nội bộ',
  'member.reportStatus.reason.riskUser': 'Người dùng kiểm soát rủi ro',
  'member.reportStatus.reason.other': 'Khác (vui lòng ghi chú)',
  'member.reportStatus.toggleSuccess': 'Chuyển thành công',
  'member.reportStatus.toggleFail': 'Chuyển thất bại',
  'member.reportStatus.fetchError': 'Tải thất bại',
  'member.reportStatus.list.title': 'Quản lý trạng thái báo cáo',
  'member.reportStatus.list.subtitle': 'Hiển thị cả hội viên tự động đóng khi đăng ký và sửa thủ công.',
  'member.reportStatus.list.statusAll': 'Tất cả',
  'member.reportStatus.list.memberAccount': 'Tài khoản hội viên',
  'member.reportStatus.list.status': 'Trạng thái hiện tại',
  'member.reportStatus.list.switchTimeRange': 'Thời gian chuyển gần nhất',
  'member.reportStatus.list.switchTime': 'Thời gian chuyển gần nhất',
  'member.reportStatus.list.operator': 'Người thao tác',
  'member.reportStatus.list.reason': 'Lý do chuyển',
  'member.reportStatus.list.detail': 'Chi tiết',
  'member.reportStatus.list.search': 'Tìm kiếm',
  'member.reportStatus.list.reset': 'Đặt lại',
  'member.reportStatus.list.export': 'Xuất',

  'member.detail.index.summary': 'Thông tin tổng quan',
  'member.detail.index.lastLogin': 'Thông tin đăng nhập gần nhất',
  'member.detail.index.certification': 'Tài liệu xác thực',
  'member.detail.index.vipInfo': 'Thông tin VIP',
  'member.detail.index.manualTags': 'Nhãn người dùng',
  'member.detail.index.remarks': 'Ghi chú',
  'member.detail.modal.addRemark.title': 'Thêm ghi chú',
  'member.detail.modal.agent.title': 'Sửa Đại Lý Cấp Trên',
  'member.detail.modal.agent.currentAgent': 'Đại Lý Cấp Trên Hiện Tại:',
  'member.detail.modal.agent.operationType': 'Chọn Loại Thao Tác:',
  'member.detail.modal.agent.modifyAgent': 'Sửa Đại Lý Cấp Trên',
  'member.detail.modal.agent.removeAgent': 'Xóa Đại Lý Cấp Trên',
  'member.detail.modal.agent.targetAgent': 'Đại Lý Mục Tiêu:',
  'member.detail.modal.agent.remark': 'Ghi Chú:',
  'member.detail.modal.agent.cancel': 'Hủy',
  'member.detail.modal.agent.confirm': 'Xác Nhận',
  'member.detail.modal.agent.inputPlaceholder': 'Vui lòng nhập',
  'member.detail.modal.agent.agentNotExist': 'Đại lý được chỉ định không tồn tại!',
  'member.detail.modal.agent.inputAgentAccount': 'Vui lòng nhập tài khoản đại lý',
  'member.detail.modal.agent.success': 'Thao tác thành công',
  'member.detail.modal.agent.error': 'Thao tác thất bại',
  'member.detail.modal.inviter.title': 'Thêm người mời',
  'member.detail.modal.inviter.currentInviter': 'Người mời hiện tại:',
  'member.detail.modal.inviter.operationType': 'Chọn loại thao tác:',
  'member.detail.modal.inviter.selectOperationType': 'Vui lòng chọn loại thao tác',
  'member.detail.modal.inviter.modifyInviter': 'Sửa đổi người mời',
  'member.detail.modal.inviter.removeInviter': 'Gỡ người mời',
  'member.detail.modal.inviter.targetInviter': 'Chỉ định người mời:',
  'member.detail.modal.inviter.inputInviterAccount': 'Vui lòng nhập tài khoản người mời',
  'member.detail.modal.inviter.inputPlaceholder': 'Vui lòng nhập',
  'member.detail.modal.inviter.inputHint': 'Có thể nhập tài khoản/UID người mời',
  'member.detail.modal.inviter.remark': 'Thông tin ghi chú:',
  'member.detail.modal.inviter.cancel': 'Hủy',
  'member.detail.modal.inviter.confirm': 'Xác nhận',
  'member.detail.modal.inviter.success': 'Thao tác thành công',
  'member.detail.modal.inviter.error': 'Thao tác thất bại',
  'member.detail.modal.inviter.inviterNotExist': 'Người mời không tồn tại',
  'member.detail.modal.inviter.noInviter': 'Không có người mời',

  // Trang danh sách thành viên
  'memberList.title': 'Danh sách thành viên',
  'memberList.searchWarning': 'Do lượng dữ liệu lớn, vui lòng kết hợp 1 điều kiện trở lên để truy vấn dữ liệu',
  'memberList.exportWarning': 'Vui lòng chọn ít nhất 3 điều kiện truy vấn để xuất',
  'memberList.timeConditionWarning': 'Khi chọn thời gian nạp đầu hoặc thời gian nạp gần nhất, vui lòng chọn thêm tiền tệ',
  'memberList.dataExceedWarning': 'Dữ liệu truy vấn đã vượt quá 1000 mục, vui lòng sử dụng chức năng xuất để xuất dữ liệu cần thiết',
  'memberList.exportExceedWarning': 'Dữ liệu xuất đã vượt quá 10000 mục, vui lòng điều chỉnh điều kiện lọc',
  'memberList.notes': 'Trang mặc định không có dữ liệu, bảng hiển thị không có dữ liệu',
  'memberList.defaultEmpty': 'Không có dữ liệu',
  'memberList.registerTime': 'Thời gian đăng ký',
  'memberList.firstRechargeTime': 'Thời gian nạp đầu',
  'memberList.lastRechargeTime': 'Thời gian nạp gần nhất',
  'memberList.lastLoginTime': 'Thời gian đăng nhập cuối',
  'memberList.mobileProvider': 'Nhà cung cấp dịch vụ',
  'memberList.mobileProviderPlaceholder': 'Chọn nhà cung cấp',
  'memberList.mobileValid': 'Trạng thái xác thực số điện thoại',
  'memberList.mobileValidPlaceholder': 'Vui lòng chọn trạng thái xác thực số điện thoại',
  'memberList.mobileValid.verified': 'Đã xác thực',
  'memberList.mobileValid.unverified': 'Chưa xác thực',
  'memberList.isAgent': 'Có đại lý cấp trên',
  'memberList.hasAgent': 'Có đại lý',
  'memberList.noAgent': 'Không có đại lý',
  'memberList.agentAccount': 'Tài khoản đại lý',
  'memberList.agentType': 'Loại đại lý',
  'memberList.agentTag': 'Nhãn đại lý',
  'memberList.topAgent': 'Đại lý cấp 1',
  'memberList.agentAccountAllUnderL1': 'Tất cả thuộc L1 này',
  'memberList.agentAccountSelectL1First': 'Vui lòng chọn đại lý cấp 1 trước',
  'memberList.defaultAgent': 'Đại lý mặc định',
  'memberList.realName': 'Tên thành viên',
  'memberList.memberAccount': 'Tài khoản thành viên',
  'memberList.memberName': 'Biệt danh thành viên',
  'memberList.vipLevels': 'Cấp VIP',
  'memberList.validInfos': 'Thông tin xác thực',
  'memberList.risks': 'Cấp độ rủi ro',
  'memberList.manualTags': 'Nhãn thủ công',
  'memberList.manualTagsPlaceholder': 'Vui lòng chọn nhãn người dùng',
  'memberList.autoTags': 'Nhãn tự động',
  'memberList.userTags': 'Nhãn người dùng',
  'memberList.userTagsPlaceholder': 'Vui lòng chọn nhãn',
  'memberList.loginLimit': 'Giới hạn đăng nhập',
  'memberList.loginLimitType': 'Loại giới hạn đăng nhập',
  'memberList.loginLimitTypePlaceholder': 'Vui lòng chọn loại giới hạn đăng nhập',
  'memberList.loginLimitType.passwordError': 'Lỗi mật khẩu đăng nhập',
  'memberList.vipLevel': 'Cấp thành viên',
  'memberList.registerInfo': 'Thông tin đăng ký',
  'memberList.registerIp': 'IP đăng ký',
  'memberList.mainBalance': 'Số dư tài khoản chính',
  'memberList.rechargeCount': 'Số lần nạp',
  'memberList.withdrawCount': 'Số lần rút',
  'memberList.totalRecharge': 'Tổng nạp',
  'memberList.totalWithdraw': 'Tổng rút',
  'memberList.validInfo': 'Thông tin xác thực',
  'memberList.memberPoints': 'Điểm thành viên',
  'memberList.riskLevel': 'Cấp độ rủi ro',
  'memberList.currency': 'Tiền tệ',
  'memberList.startDate': 'Ngày bắt đầu',
  'memberList.endDate': 'Ngày kết thúc',
  'memberList.search': 'Tìm kiếm',
  'memberList.reset': 'Đặt lại',
  'memberList.export': 'Xuất',
  'memberList.export.loading': 'Đang xuất...',
  'memberList.export.success': 'Xuất thành công',
  'memberList.requestFailed': 'Yêu cầu thất bại',
  'memberList.action': 'Thao tác',
  'memberList.view': 'Xem',
  'memberList.batchSetRisk': 'Cài đặt rủi ro hàng loạt',
  'memberList.noData': 'Không có dữ liệu',
  'memberList.upload.selected': 'Xóa tệp đã chọn',
  'memberList.upload.running': 'Đang tải lên',
  'memberList.upload.success': 'Tải lên thành công',
  'memberList.upload.failed': 'Tải lên không thành công',
  'memberList.upload.file.size': 'Tệp không được vượt quá 2GB',
  'memberList.upload.title': 'Tải lên thông tin thành viên CSV',
  'memberList.upload.selected.area': 'Nhấp hoặc kéo tệp vào khu vực này để tải lên',
  'memberList.upload.selected.area.bottom': 'Chỉ hỗ trợ tệp CSV, kích thước tối đa 40MB. Tên trường phải đáp ứng yêu cầu của máy chủ. Cột tiêu đề gồm: username, date_of_birth, user_type, version, ...; user_type hỗ trợ NORMAL / STORE, người dùng cửa hàng cần điền version: V1 / V2.',
  'memberList.upload.button': 'Tải lên',

  // Tùy chọn thông tin xác thực
  'memberList.validInfo.realName': 'Xác thực thực danh',
  'memberList.validInfo.mobile': 'Xác thực di động',
  'memberList.validInfo.email': 'Xác thực email',
  'memberList.validInfo.kyc': 'Xác thực KYC',

  // Nhãn thông tin xác thực
  'memberList.validInfo.realNameTag': 'Thực danh',
  'memberList.validInfo.mobileTag': 'Di động',
  'memberList.validInfo.emailTag': 'Email',
  'memberList.validInfo.kycTag': 'KYC',
  'memberList.validInfo.verification': ' nhận ra',

  // Tùy chọn cấp độ rủi ro
  'memberList.riskLevel.limitLogin': 'Hạn chế đăng nhập',
  'memberList.riskLevel.limitDeposit': 'Hạn chế nạp tiền',
  'memberList.riskLevel.limitWithdraw': 'Hạn chế rút tiền',
  'memberList.riskLevel.limitBonus': 'Hạn chế nhận khuyến mãi',
  'memberList.riskLevel.suspiciousRisk': 'Nghi ngờ rủi ro',
  'memberList.riskLevel.normal': 'Bình thường',
  'memberList.riskLevel.sameIpRisk': 'Cùng IP rủi ro',
  'memberList.riskLevel.sameDeviceRisk': 'Cùng thiết bị rủi ro',
  'memberList.riskLevel.sameBankCardRisk': 'Cùng thẻ ngân hàng rủi ro',
  'memberList.riskLevel.sameWalletRisk': 'Cùng ví rủi ro',

  // Tùy chọn ngày nhanh
  'memberList.quickDate.today': 'Hôm nay',
  'memberList.quickDate.yesterday': 'Hôm qua',
  'memberList.quickDate.last7Days': '7 ngày gần nhất',
  'memberList.quickDate.last30Days': '30 ngày gần nhất',
  'memberList.quickDate.thisWeek': 'Tuần này',
  'memberList.quickDate.lastWeek': 'Tuần trước',
  'memberList.quickDate.thisMonth': 'Tháng này',
  'memberList.quickDate.lastMonth': 'Tháng trước',

  // Tùy chọn kênh đăng nhập
  'memberList.loginChannel.label': 'Kênh đăng nhập',
  'memberList.loginChannel.placeholder': 'Vui lòng chọn kênh đăng nhập',
  'memberList.loginChannel.all': 'Tất cả',
  'memberList.loginChannel.others': 'Khác',
  'memberList.loginChannel.web': 'Web',
  'memberList.loginChannel.androidApp': 'Android APP',
  'memberList.loginChannel.androidH5': 'Android H5',
  'memberList.loginChannel.androidPwa': 'Android PWA',
  'memberList.loginChannel.iosH5': 'iOS H5',
  'memberList.loginChannel.iosPwa': 'iOS PWA',
  'memberList.loginChannel.iosApp': 'IOS APP',

  // Đơn vị
  'memberList.unit.times': ' lần',
  'member.detail.modal.addRemark.content': 'Nội dung ghi chú',
  'member.detail.modal.addRemark.placeholder': 'Nhập ghi chú',
  'member.detail.modal.addRemark.isTop': 'Ghim lên đầu',
  'member.detail.modal.addRemark.success': 'Thêm ghi chú thành công',
  'member.detail.modal.addRemark.error': 'Thêm ghi chú thất bại',
  'member.detail.modal.editEmail.title': 'Email',
  'member.detail.modal.editEmail.email': 'Email',
  'member.detail.modal.editEmail.emailPlaceholder': 'Nhập email',
  'member.detail.modal.editEmail.emailError': 'Email không hợp lệ',
  'member.detail.modal.editEmail.remark': 'Ghi chú',
  'member.detail.modal.editEmail.remarkPlaceholder': 'Nhập ghi chú',
  'member.detail.modal.editEmail.success': 'Cập nhật email thành công',
  'member.detail.modal.editEmail.error': 'Cập nhật email thất bại',
  'member.detail.modal.editEmail.emailExists': 'Email đã tồn tại',
  'member.detail.modal.editIdentity.title': 'Thông tin cá nhân',
  'member.detail.modal.editIdentity.realName': 'Họ tên',
  'member.detail.modal.editIdentity.realNamePlaceholder': 'Nhập họ tên',
  'member.detail.modal.editIdentity.birthdayTime': 'Ngày sinh',
  'member.detail.modal.editIdentity.remark': 'Ghi chú',
  'member.detail.modal.editIdentity.remarkPlaceholder': 'Nhập ghi chú',
  'member.detail.modal.editIdentity.success': 'Cập nhật thông tin thành công',
  'member.detail.modal.editIdentity.error': 'Cập nhật thông tin thất bại',
  'member.detail.modal.editKyc.title': 'Cập nhật KYC',
  'member.detail.modal.editKyc.legalName': 'Tên hợp pháp',
  'member.detail.modal.editKyc.legalNamePlaceholder': 'Nhập tên hợp pháp',
  'member.detail.modal.editKyc.birthDate': 'Ngày sinh',
  'member.detail.modal.editKyc.idCardUrl': 'CMND/CCCD',
  'member.detail.modal.editKyc.success': 'Cập nhật KYC thành công',
  'member.detail.modal.editKyc.error': 'Cập nhật KYC thất bại',
  'member.detail.modal.editPhone.title': 'Số điện thoại',
  'member.detail.modal.editPhone.phoneNumber': 'Số điện thoại',
  'member.detail.modal.editPhone.phoneNumberPlaceholder': 'Nhập số điện thoại',
  'member.detail.modal.editPhone.phoneNumberError': 'Số điện thoại không hợp lệ',
  'member.detail.modal.editPhone.remark': 'Ghi chú',
  'member.detail.modal.editPhone.remarkPlaceholder': 'Nhập ghi chú',
  'member.detail.modal.editPhone.success': 'Cập nhật số điện thoại thành công',
  'member.detail.modal.editPhone.error': 'Cập nhật số điện thoại thất bại',
  'member.detail.modal.editPhone.phoneExists': 'Số điện thoại đã tồn tại',
  'member.detail.modal.editRiskLevel.title': 'Cấp độ rủi ro',
  'member.detail.modal.editRiskLevel.riskLevel': 'Cấp độ rủi ro',
  'member.detail.modal.editRiskLevel.riskLevelPlaceholder': 'Chọn cấp độ rủi ro',
  'member.detail.modal.editRiskLevel.remark': 'Ghi chú',
  'member.detail.modal.editRiskLevel.remarkPlaceholder': 'Nhập ghi chú',
  'member.detail.modal.editRiskLevel.success': 'Cập nhật cấp độ rủi ro thành công',
  'member.detail.modal.editRiskLevel.error': 'Cập nhật cấp độ rủi ro thất bại',
  'member.detail.modal.editRiskLevel.limitLogin': 'Giới hạn đăng nhập',
  'member.detail.modal.editRiskLevel.limitDeposits': 'Giới hạn nạp tiền',
  'member.detail.modal.editRiskLevel.limitWithdrawal': 'Giới hạn rút tiền',
  'member.detail.modal.editRiskLevel.limitDiscount': 'Giới hạn nhận khuyến mãi',
  'member.detail.modal.editRiskLevel.potentialRisk': 'Nghi ngờ rủi ro',
  'member.detail.modal.editRiskLevel.sameIpRisk': 'Cùng IP rủi ro',
  'member.detail.modal.editRiskLevel.sameDeviceRisk': 'Cùng thiết bị rủi ro',
  'member.detail.modal.editRiskLevel.sameBankCardRisk': 'Cùng thẻ ngân hàng rủi ro',
  'member.detail.modal.editRiskLevel.sameWalletRisk': 'Cùng ví rủi ro',
  'member.detail.modal.editRiskLevel.loginLimitType': 'Loại giới hạn đăng nhập',
  'member.detail.modal.editRiskLevel.loginLimitTypePlaceholder': 'Vui lòng chọn loại giới hạn đăng nhập',
  'member.detail.modal.editRiskLevel.loginLimitTypeRequired': 'Vui lòng chọn loại giới hạn đăng nhập',
  'member.detail.modal.resetPassword.title': 'Đặt lại mật khẩu',
  'member.detail.modal.resetPassword.confirmText': 'Xác nhận đặt lại mật khẩu?',
  'member.detail.modal.resetPassword.successTitle': 'Đặt lại mật khẩu thành công',
  'member.detail.modal.resetPassword.successText': 'Mật khẩu mới:',
  'member.detail.modal.resetPassword.okText': 'Đã hiểu',
  'member.detail.modal.resetPassword.error': 'Đặt lại mật khẩu thất bại',
  'member.detail.modal.resetWithdrawPassword.title': 'Đặt lại mật khẩu rút tiền',
  'member.detail.modal.resetWithdrawPassword.confirmText': 'Xác nhận đặt lại mật khẩu rút tiền?',
  'member.detail.modal.resetWithdrawPassword.successTitle': 'Đặt lại mật khẩu thành công',
  'member.detail.modal.resetWithdrawPassword.successText': 'Mật khẩu mới:',
  'member.detail.modal.resetWithdrawPassword.okText': 'Đã hiểu',
  'member.detail.modal.resetWithdrawPassword.error': 'Đặt lại mật khẩu thất bại',
  'member.detail.basicInfo.memberAccount': 'Tài khoản thành viên',
  'member.detail.basicInfo.memberName': 'Tên thành viên',
  'member.detail.basicInfo.agentInviteCode': 'Mã đại lý',
  'member.detail.basicInfo.isAppUser': 'Người dùng APP',
  'member.detail.basicInfo.agentName': 'Đại lý trực thuộc',
  'member.detail.basicInfo.rootInviter': 'Bạn bè cấp cao nhất',
  'member.detail.basicInfo.sameAsParentInviter': 'Giống bạn bè cấp trên',
  'member.detail.basicInfo.parentInviter': 'Bạn bè cấp trên',
  'member.detail.basicInfo.inviterCode': 'Mã mời bạn bè',
  'member.detail.basicInfo.generateInviterCode': 'Tạo',
  'member.detail.basicInfo.generateInviterCodeSuccess': 'Tạo mã mời bạn bè thành công',
  'member.detail.basicInfo.generateInviterCodeFailed': 'Tạo mã mời bạn bè thất bại',
  'member.detail.basicInfo.riskLevel': 'Cấp độ rủi ro',
  'member.detail.basicInfo.registerTime': 'Thời gian đăng ký',
  'member.detail.basicInfo.registerSource': 'Nguồn đăng ký',
  'member.detail.basicInfo.limitLogin': 'Giới hạn đăng nhập',
  'member.detail.basicInfo.limitDeposits': 'Giới hạn nạp tiền',
  'member.detail.basicInfo.limitWithdrawal': 'Giới hạn rút tiền',
  'member.detail.basicInfo.limitDiscount': 'Giới hạn nhận khuyến mãi',
  'member.detail.userTypeSetting.title': 'Thiết lập loại người dùng',
  'member.detail.userTypeSetting.userType.label': 'Loại người dùng',
  'member.detail.userTypeSetting.userType.normal': 'Người dùng thường',
  'member.detail.userTypeSetting.userType.store': 'Người dùng cửa hàng',
  'member.detail.userTypeSetting.displayVersion.label': 'Phiên bản hiển thị',
  'member.detail.userTypeSetting.displayVersion.required': 'Vui lòng chọn phiên bản hiển thị',
  'member.detail.userTypeSetting.displayVersion.placeholder': 'Vui lòng chọn phiên bản hiển thị',
  'member.detail.userTypeSetting.displayVersion.hint': 'Quy tắc phiên bản do hệ thống định nghĩa (xem bảng ánh xạ bên dưới); chọn phiên bản để gán cho người dùng này.',
  'member.detail.userTypeSetting.version.v1': 'Phiên bản 1 (ecasino)',
  'member.detail.userTypeSetting.version.v2': 'Phiên bản 2 (ecasino + ebingo)',
  'member.detail.userTypeSetting.offering.egames': 'E-Games',
  'member.detail.userTypeSetting.offering.ebingo': 'E-Bingo',
  'member.detail.userTypeSetting.offering.sportsbook': 'Sportsbook',
  'member.detail.userTypeSetting.offering.traditional': 'Traditional Bingo',
  'member.detail.userTypeSetting.cat.ebingo': 'bingo (trừ Bingo Pilipino Live)',
  'member.detail.userTypeSetting.cat.traditional': 'Bingo Pilipino Live (OTB)',
  'member.detail.userTypeSetting.excl.sgPoker': 'poker của SG',
  'member.detail.userTypeSetting.excl.sgLive': 'livecasino của SG',
  'member.detail.userTypeSetting.excl.none': 'Không có loại trừ',
  'member.detail.userTypeSetting.preview.includeTitle': 'Danh mục hiển thị / tìm kiếm',
  'member.detail.userTypeSetting.preview.excludeTitle': 'Loại trừ (ẩn / không tìm được)',
  'member.detail.userTypeSetting.preview.normalNote': 'Người dùng thường truy cập toàn bộ catalog trực tuyến, không lọc theo phiên bản; trường phiên bản hiển thị bị ẩn.',
  'member.detail.userTypeSetting.mapping.name': 'Display Version',
  'member.detail.userTypeSetting.defaultHint': 'Người dùng hiện có mặc định được xem là người dùng thường.',
  'member.detail.userTypeSetting.preview.title': 'Danh mục game người dùng có thể xem và tìm kiếm (xem trước)',
  'member.detail.userTypeSetting.preview.empty': 'Chọn phiên bản hiển thị để xem trước danh mục khả dụng',
  'member.detail.userTypeSetting.preview.all': 'Tất cả danh mục',
  'member.detail.userTypeSetting.preview.liveNoSg': 'livecasino (không gồm SG)',
  'member.detail.userTypeSetting.preview.pokerNoSg': 'poker (không gồm SG)',
  'member.detail.userTypeSetting.preview.bingoNoLive': 'bingo (không gồm FBM live bingo)',
  'member.detail.userTypeSetting.annot.effect': 'Có hiệu lực từ lần đăng nhập tiếp theo',
  'member.detail.userTypeSetting.annot.searchCover': 'Kết quả tìm kiếm dùng cùng bộ lọc danh mục',
  'member.detail.userTypeSetting.annot.versionFilter': 'Backend lọc theo phiên bản',
  'member.detail.userTypeSetting.mapping.title': 'Ánh xạ phiên bản với danh mục game nền tảng (hệ thống định nghĩa, chỉ để tham khảo)',
  'member.detail.userTypeSetting.mapping.version': 'Phiên bản',
  'member.detail.userTypeSetting.mapping.includes': 'Danh mục hiển thị',
  'member.detail.userTypeSetting.mapping.excludes': 'Danh mục loại trừ',
  'member.detail.userTypeSetting.mapping.v1Excludes': 'poker và livecasino của SG',
  'member.detail.userTypeSetting.mapping.v2Excludes': 'poker và livecasino của SG; FBM live bingo',
  'member.detail.userTypeSetting.footer.permNote': 'Quyền truy cập được kiểm soát theo vai trò',
  'member.detail.userTypeSetting.save': 'Lưu',
  'member.detail.userTypeSetting.success': 'Thiết lập loại người dùng thành công',
  'member.detail.userTypeSetting.error': 'Thiết lập loại người dùng thất bại',
  'member.detail.kycInfo.realName': 'Họ tên',
  'member.detail.kycInfo.birthDate': 'Ngày sinh',
  'member.detail.kycInfo.kycStatus': 'Trạng thái KYC',
  'member.detail.kycInfo.email': 'Email',
  'member.detail.kycInfo.phoneNumber': 'Số điện thoại',
  'member.detail.kycInfo.mobileProvider': 'Nhà cung cấp dịch vụ',
  'member.detail.kycInfo.viewPhone': 'Xem số điện thoại',
  'member.detail.kycInfo.viewEmail': 'Xem email',
  'member.detail.kycInfo.fetchEmailError': 'Không thể lấy email',
  'member.detail.kycInfo.mobileValid.verified': 'Đã xác thực',
  'member.detail.kycInfo.mobileValid.unverified': 'Chưa xác thực',
  'member.detail.kycInfo.emailValid.verified': 'Đã xác thực',
  'member.detail.kycInfo.emailValid.unverified': 'Chưa xác thực',
  'member.detail.kycInfo.simple.pending': 'Đang chờ xem xét đăng ký KYC',
  'member.detail.kycInfo.whole.pending': 'Đang chờ xem xét rút KYC',
  'member.detail.kycInfo.simple.success': 'Đăng ký KYC thành công',
  'member.detail.kycInfo.whole.success': 'Rút KYC thành công',
  'member.detail.kycInfo.simple.failed': 'Đăng ký KYC không thành công',
  'member.detail.kycInfo.whole.failed': 'Rút KYC không thành công',
  'member.detail.kycInfo.simple.blacklist': 'Đăng ký KYC danh sách đen',
  'member.detail.kycInfo.whole.blacklist': 'Rút khỏi KYC danh sách đen',
  'member.detail.kycInfo.notSubmitted': 'Chưa nộp',
  'member.detail.vipInfo.upgradeGrow': 'Điểm VIP (nâng cấp)',
  'member.detail.vipInfo.retentionGrow': 'Điểm VIP (duy trì)',
  'member.detail.vipInfo.vipLevel': 'Cấp VIP',
  'member.detail.vipInfo.vipGrow': 'Điểm VIP',
  'member.detail.vipInfo.noVipInfo': 'Chưa có thông tin VIP',
  'member.detail.vipInfo.fetchError': 'Lỗi lấy thông tin VIP',
  'member.detail.vipInfo.permanentRetention': 'Duy trì vĩnh viễn',
  'member.detail.countryArea.error': 'Lỗi lấy mã vùng',
  'member.detail.memberInfo.error': 'Lỗi lấy thông tin thành viên',
  'member.detail.remarkInfo.noMemberSelected': 'Vui lòng chọn thành viên',
  'member.detail.remarkInfo.remarkContent': 'Nội dung ghi chú',
  'member.detail.remarkInfo.isTop': 'Ghim lên đầu',
  'member.detail.remarkInfo.createTime': 'Thời gian tạo',
  'member.detail.remarkInfo.createUser': 'Người tạo',
  'member.detail.remarkInfo.operation': 'Thao tác',
  'member.detail.remarkInfo.delete': 'Xóa',
  'member.detail.remarkInfo.cancelTop': 'Bỏ ghim',
  'member.detail.remarkInfo.setTop': 'Ghim',
  'member.detail.remarkInfo.confirmDelete': 'Xác nhận xóa ghi chú?',
  'member.detail.remarkInfo.confirm': 'Xác nhận',
  'member.detail.remarkInfo.cancel': 'Hủy',
  'member.detail.remarkInfo.deleteSuccess': 'Xóa ghi chú thành công',
  'member.detail.remarkInfo.deleteError': 'Xóa ghi chú thất bại',
  'member.detail.remarkInfo.topSuccess': 'Ghim thành công',
  'member.detail.remarkInfo.cancelTopSuccess': 'Bỏ ghim thành công',
  'member.detail.remarkInfo.topError': 'Ghim thất bại',
  'member.detail.remarkInfo.cancelTopError': 'Bỏ ghim thất bại',
  'member.detail.remarkInfo.yes': 'Có',
  'member.detail.remarkInfo.no': 'Không',
  'member.detail.common.noData': 'Không có dữ liệu',
  'member.detail.common.dash': '-',
  'member.betting.columns.index': 'STT',
  'member.betting.columns.betTime': 'Thời gian cược',
  'member.betting.columns.betAmount': 'Số tiền cược',
  'member.betting.columns.winLossAmount': 'Số tiền thắng/thua',
  'member.betting.columns.platformCode': 'Tên nền tảng',
  'member.betting.columns.gameType': 'Loại game',
  'member.betting.gameTypes.1': 'Slot',
  'member.betting.gameTypes.2': 'Live',
  'member.betting.gameTypes.3': 'Thể thao',
  'member.betting.gameTypes.4': 'Xổ số',
  'member.betting.gameTypes.5': 'Bắn cá',
  'member.betting.gameTypes.6': 'Bài',
  'member.betting.gameTypes.7': '3D',
  'member.betting.gameTypes.10': 'Thể thao điện tử',
  'member.betting.gameTypes.12': 'Bingo',
  'member.betting.currentPageTotal': 'Tổng cộng trang hiện tại',
  'member.welfare.columns.claimTime': 'Thời gian nhận',
  'member.welfare.columns.promotionName': 'Tên khuyến mãi',
  'member.welfare.columns.promotionAmount': 'Số tiền',
  'member.welfare.columns.promotionTemplate': 'Mẫu khuyến mãi',
  'member.welfare.columns.sender': 'Người gửi',
  'member.welfare.columns.status': 'Trạng thái',
  'member.welfare.status.0': 'Chờ nhận',
  'member.welfare.status.1': 'Hoàn thành',
  'member.welfare.status.2': 'Đã hết hạn',
  'member.trade.columns.transactionTime': 'Thời gian giao dịch',
  'member.trade.columns.type': 'Loại',
  'member.trade.columns.details': 'Chi tiết',
  'member.trade.columns.beforeAmount': 'Số dư trước',
  'member.trade.columns.amount': 'Số tiền',
  'member.trade.columns.afterAmount': 'Số dư sau',
  'member.trade.columns.operator': 'Người thao tác',
  'member.trade.types.1001': 'Nạp tiền',
  'member.trade.types.1002': 'Rút tiền',
  'member.trade.types.3999': 'Khuyến mãi thủ công',
  'member.trade.types.3001': 'Thưởng nâng cấp VIP',
  'member.trade.types.3002': 'Thưởng duy trì VIP',
  'member.trade.types.3003': 'Lương tuần VIP',
  'member.trade.types.3004': 'Lương tháng VIP',
  'member.trade.types.3005': 'Thưởng sinh nhật VIP',
  'member.trade.types.3006': 'Điểm nâng cấp VIP',
  'member.trade.types.3007': 'Điểm duy trì VIP',
  'member.trade.types.3008': 'Điểm hàng ngày App VIP',
  'member.trade.types.3009': 'Điểm hàng ngày H5 VIP',
  'member.trade.types.3010': 'Thưởng hoàn trả game VIP',
  'member.trade.types.3011': 'Thưởng hoàn trả',
  'member.trade.types.3012': 'Thưởng đăng ký',
  'member.trade.types.3013': 'Thưởng nạp tiền',
  'member.trade.types.3014': 'Thưởng nạp đầu tiên hàng ngày',
  'member.trade.types.3015': 'Đăng nhập',
  'member.trade.types.3016': 'Nạp tiền',
  'member.trade.types.3017': 'Thưởng mã đổi',
  'member.trade.types.3018': 'Thưởng quay may mắn',
  'member.trade.types.3019': 'Thưởng nạp tiền mỗi lần',
  'member.trade.types.3030': 'Ưu đãi nạp lần đầu',
  'member.trade.types.3031': 'Thưởng hoạt động bảng xếp hạng',
  'member.trade.types.3020': 'Thưởng mời',
  'member.trade.types.3021': 'Thưởng thành tựu',
  'member.trade.types.3022': 'Thưởng được mời',
  'member.trade.types.3023': 'Thưởng ràng buộc thông tin',
  'member.trade.types.3024': 'Thưởng Hộp Kho báu',
  'member.trade.types.3026': 'Mưa phong bì',
  'member.trade.types.3028': 'Giải thưởng Hộp Kho báu',
  'member.trade.types.3029': 'Thưởng hoàn trả mới',
  'member.trade.types.3032': 'Hoàn tiền nạp mời bạn',
  'member.trade.types.3033': 'Hoàn tiền cược mời bạn',
  'member.trade.types.3034': 'Hoàn tiền thắng/thua mời bạn',
  'member.trade.types.3035': 'Hoàn tiền NGR mời bạn',
  'member.trade.types.5001': 'Nhập thủ công',
  'member.trade.types.5002': 'Xuất thủ công',
  'member.trade.types.5003': 'Nhập thủ công (không tính doanh thu)',
  'member.trade.types.5004': 'Xuất thủ công (không tính doanh thu)',
  'member.trade.types.5005': 'Thanh toán nợ xấu',
  'member.trade.types.5006': 'Đại lý nạp',
  'member.trade.types.5007': 'Đại lý chuyển ra',
  'member.trade.types.6001': 'Chuyển vào game',
  'member.trade.types.6002': 'Chuyển ra game',
  'member.trade.types.7001': 'Đổi điểm',
  'member.trade.types.9001': 'Nạp tiền nhận nhiên liệu',
  'member.trade.types.9002': 'Mời bạn nhận nhiên liệu',
  'member.trade.types.9003': 'Thưởng vào cửa',
  'member.trade.types.9004': 'Thưởng vượt ải',
  'member.trade.types.9005': 'Đổi điểm lấy nhiên liệu',
  'member.trade.types.OTHER': 'Khác',
  'member.point.columns.changeDate': 'Ngày thay đổi',
  'member.point.columns.changeType': 'Loại thay đổi',
  'member.point.columns.beforePoints': 'Điểm trước',
  'member.point.columns.changeAmount': 'Số điểm thay đổi',
  'member.point.columns.afterPoints': 'Điểm sau',
  'member.point.columns.remark': 'Ghi chú',
  'member.point.changeTypes.increase': 'Tăng',
  'member.point.changeTypes.decrease': 'Giảm',
  'member.point.manualAdjust.title': 'Điều chỉnh điểm',
  'member.point.manualAdjust.currentPoints': 'Điểm hiện tại',
  'member.point.manualAdjust.adjustType': 'Loại điều chỉnh',
  'member.point.manualAdjust.adjustPoints': 'Điểm điều chỉnh',
  'member.point.manualAdjust.validDate': 'Ngày hết hạn',
  'member.point.manualAdjust.submitRemark': 'Ghi chú',
  'member.point.manualAdjust.increasePoints': 'Tăng điểm',
  'member.point.manualAdjust.decreasePoints': 'Giảm điểm',
  'member.point.manualAdjust.placeholder': 'Nhập',
  'member.point.manualAdjust.success': 'Điều chỉnh thành công',
  'member.point.manualAdjust.error': 'Điều chỉnh thất bại',
  'member.point.manualAdjust.getPointsError': 'Lỗi lấy điểm',
  'wallet.accountBalance.title': 'Ví tài khoản',
  'wallet.accountBalance.totalBalance': 'Tổng số dư',
  'wallet.accountBalance.mainBalance': 'Tài khoản chính',
  'wallet.accountBalance.memberPoints': 'Điểm thành viên',
  'wallet.accountBalance.noPlatformData': 'Không có dữ liệu',
  'wallet.accountBalance.manualAdjust.title': 'Điều chỉnh thủ công',
  'wallet.accountBalance.manualAdjust.currency': 'Tiền tệ',
  'wallet.accountBalance.manualAdjust.currencyPlaceholder': 'Chọn tiền tệ',
  'wallet.accountBalance.manualAdjust.adjustType': 'Loại điều chỉnh',
  'wallet.accountBalance.manualAdjust.adjustTypePlaceholder': 'Chọn loại',
  'wallet.accountBalance.manualAdjust.increaseAmount': 'Tăng tiền',
  'wallet.accountBalance.manualAdjust.decreaseAmount': 'Giảm tiền',
  'wallet.accountBalance.manualAdjust.amount': 'Số tiền',
  'wallet.accountBalance.manualAdjust.amountPlaceholder': 'Nhập số tiền',
  'wallet.accountBalance.manualAdjust.increaseFlow': 'Tăng doanh thu',
  'wallet.accountBalance.manualAdjust.decreaseFlow': 'Giảm doanh thu',
  'wallet.accountBalance.manualAdjust.flowPlaceholder': 'Nhập doanh thu',
  'wallet.accountBalance.manualAdjust.memoPayDeposit': 'Tính vào nạp/rút',
  // —— Hoàn lại hạn mức khi trừ ——
  'wallet.accountBalance.manualAdjust.refund.label': 'Xử lý hạn mức',
  'wallet.accountBalance.manualAdjust.refund.checkbox': 'Có hoàn hạn mức?',
  'wallet.accountBalance.manualAdjust.refund.hint': 'Mặc định không hoàn (toàn bộ khoản trừ về nền tảng). Đánh dấu để phân bổ thủ công cho từng nguồn; mỗi dòng ≤ hạn mức có thể hoàn, tổng ≤ số tiền trừ, phần dư về nền tảng.',
  'wallet.accountBalance.manualAdjust.refund.detailTitle': 'Chi tiết hoàn',
  'wallet.accountBalance.manualAdjust.refund.colSource': 'Nguồn',
  'wallet.accountBalance.manualAdjust.refund.colRefundable': 'Hạn mức có thể hoàn',
  'wallet.accountBalance.manualAdjust.refund.colAlreadyRefunded': 'Đã hoàn',
  'wallet.accountBalance.manualAdjust.refund.colRefund': 'Hoàn lần này',
  'wallet.accountBalance.manualAdjust.refund.totalRefund': 'Tổng hoàn',
  'wallet.accountBalance.manualAdjust.refund.totalDeduct': 'Tổng trừ',
  'wallet.accountBalance.manualAdjust.refund.platformResidual': 'Phần dư (về nền tảng)',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUser': 'Tài khoản BG',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUserPlaceholder': 'Hạn mức điều chỉnh tài khoản BG',
  'wallet.accountBalance.manualAdjust.refund.sourceL1': 'Đại lý cấp 1',
  'wallet.accountBalance.manualAdjust.refund.sourceL2': 'Đại lý cấp 2',
  'wallet.accountBalance.manualAdjust.refund.empty': 'Không có nguồn nào có thể hoàn',
  'wallet.accountBalance.manualAdjust.refund.errorRowExceed': '⚠ Có dòng vượt quá hạn mức có thể hoàn',
  'wallet.accountBalance.manualAdjust.refund.errorSumExceed': '⚠ Tổng hoàn vượt quá tổng trừ',
  'wallet.accountBalance.manualAdjust.refund.fetchFail': 'Tải nguồn hoàn thất bại',
  'wallet.accountBalance.manualAdjust.remark': 'Ghi chú',
  'wallet.accountBalance.manualAdjust.remarkPlaceholder': 'Nhập ghi chú',
  'wallet.accountBalance.manualAdjust.confirm': 'Xác nhận',
  'wallet.accountBalance.manualAdjust.cancel': 'Hủy',
  'wallet.accountBalance.manualAdjust.success': 'Thành công',
  'wallet.accountBalance.manualAdjust.error': 'Thất bại',
  'wallet.bankCards.title': 'Thẻ ngân hàng',
  'wallet.bankCards.bindTime': 'Thời gian liên kết',
  'wallet.bankCards.bankName': 'Ngân hàng',
  'wallet.bankCards.cardHolder': 'Chủ thẻ',
  'wallet.bankCards.cardNumber': 'Số thẻ',
  'wallet.bankCards.status': 'Trạng thái',
  'wallet.bankCards.enabled': 'Kích hoạt',
  'wallet.bankCards.disabled': 'Vô hiệu hóa',
  'wallet.bankCards.actions.unbind': 'Hủy liên kết',
  'wallet.bankCards.actions.enable': 'Kích hoạt',
  'wallet.bankCards.actions.disable': 'Vô hiệu hóa',
  'wallet.bankCards.actions.confirmUnbind': 'Xác nhận hủy liên kết',
  'wallet.bankCards.actions.confirmUnbindContent': 'Xác nhận hủy liên kết thẻ?',
  'wallet.bankCards.actions.confirmEnable': 'Xác nhận kích hoạt',
  'wallet.bankCards.actions.confirmEnableContent': 'Xác nhận kích hoạt thẻ?',
  'wallet.bankCards.actions.confirmDisable': 'Xác nhận vô hiệu hóa',
  'wallet.bankCards.actions.confirmDisableContent': 'Xác nhận vô hiệu hóa thẻ?',
  'wallet.bankCards.actions.unbindSuccess': 'Hủy liên kết thành công',
  'wallet.bankCards.actions.unbindError': 'Hủy liên kết thất bại',
  'wallet.bankCards.actions.enableSuccess': 'Kích hoạt thành công',
  'wallet.bankCards.actions.enableError': 'Kích hoạt thất bại',
  'wallet.bankCards.actions.disableSuccess': 'Vô hiệu hóa thành công',
  'wallet.bankCards.actions.disableError': 'Vô hiệu hóa thất bại',
  'wallet.financialOverview.title': 'Tổng quan tài chính',
  'wallet.financialOverview.totalDeposit': 'Tổng nạp',
  'wallet.financialOverview.totalWithdrawal': 'Tổng rút',
  'wallet.financialOverview.firstDeposit': 'Nạp đầu',
  'wallet.financialOverview.depositCount': 'Số lần nạp',
  'wallet.financialOverview.withdrawalCount': 'Số lần rút',
  'wallet.financialOverview.totalBonus': 'Tổng khuyến mãi',
  'wallet.financialOverview.firstDepositTime': 'Thời gian nạp đầu',
  'wallet.financialOverview.lastDeposit': 'Nạp gần nhất',
  'wallet.financialOverview.lastDepositTime': 'Thời gian nạp gần nhất',
  'wallet.financialOverview.historicalProfitLoss': 'Lợi nhuận/Lỗ lịch sử',
  'wallet.financialOverview.historicalProfitLossDesc1': 'Lợi nhuận/Lỗ lịch sử: Thống kê tất cả dữ liệu lợi nhuận/lỗ của bên thứ ba trước ngày hôm qua.',
  'wallet.financialOverview.historicalProfitLossDesc2': 'Màu số tiền (thống nhất với logic màu của cược trong bảy ngày gần đây).',
  'wallet.financialOverview.historicalProfitLossDesc3': 'Đỏ: Thua, Xanh: Thắng.',
  'wallet.financialOverview.totalBetFlowAmount': 'Tổng dòng hiệu lực',
  'wallet.financialOverview.pointExchangeAmount': 'Số tiền đổi điểm',
  'wallet.financialOverview.todayDepositAmount': 'Nạp hôm nay',
  'wallet.financialOverview.todayWithdrawAmount': 'Rút hôm nay',
  'wallet.financialOverview.todayProfitAmount': 'Lợi nhuận hôm nay',
  'wallet.financialOverview.todayBetAmount': 'Cược hôm nay',
  'wallet.financialOverview.todayBonusAmount': 'Thưởng hôm nay (gồm đổi điểm)',
  'wallet.financialOverview.fetchError': 'Không thể lấy tổng quan tài chính',
  'wallet.financialOverview.historicalProfitLossFetchError': 'Không thể lấy lợi nhuận/lỗ lịch sử',
  'wallet.walletAccounts.title': 'Thông tin ví',
  'wallet.walletAccounts.bindTime': 'Thời gian liên kết',
  'wallet.walletAccounts.walletType': 'Loại ví',
  'wallet.walletAccounts.walletName': 'Tên ví',
  'wallet.walletAccounts.walletAccount': 'Tài khoản ví',
  'wallet.walletAccounts.usdtType': 'Loại USDT',
  'wallet.walletAccounts.status': 'Trạng thái',
  'wallet.walletAccounts.enabled': 'Kích hoạt',
  'wallet.walletAccounts.disabled': 'Vô hiệu hóa',
  'wallet.walletAccounts.actions.unbind': 'Hủy liên kết',
  'wallet.walletAccounts.actions.enable': 'Kích hoạt',
  'wallet.walletAccounts.actions.disable': 'Vô hiệu hóa',
  'wallet.walletAccounts.actions.confirmUnbind': 'Xác nhận hủy liên kết',
  'wallet.walletAccounts.actions.confirmUnbindContent': 'Xác nhận hủy liên kết ví?',
  'wallet.walletAccounts.actions.confirmEnable': 'Xác nhận kích hoạt',
  'wallet.walletAccounts.actions.confirmEnableContent': 'Xác nhận kích hoạt ví?',
  'wallet.walletAccounts.actions.confirmDisable': 'Xác nhận vô hiệu hóa',
  'wallet.walletAccounts.actions.confirmDisableContent': 'Xác nhận vô hiệu hóa ví?',
  'wallet.walletAccounts.actions.unbindSuccess': 'Hủy liên kết thành công',
  'wallet.walletAccounts.actions.unbindError': 'Hủy liên kết thất bại',
  'wallet.walletAccounts.actions.statusUpdateSuccess': 'Cập nhật thành công',
  'wallet.walletAccounts.actions.statusUpdateError': 'Cập nhật thất bại',
  'wallet.withdrawalHistory.title': 'Lịch sử rút tiền',
  'wallet.withdrawalHistory.remainingFlow': 'Doanh thu còn lại',
  'wallet.withdrawalHistory.completedFlow': 'Doanh thu đã hoàn thành',
  'wallet.withdrawalHistory.totalFlow': 'Tổng doanh thu yêu cầu',
  'wallet.withdrawalHistory.manualAdjust.title': 'Điều chỉnh doanh thu',
  'wallet.withdrawalHistory.manualAdjust.currency': 'Tiền tệ',
  'wallet.withdrawalHistory.manualAdjust.currencyPlaceholder': 'Chọn tiền tệ',
  'wallet.withdrawalHistory.manualAdjust.adjustType': 'Loại điều chỉnh',
  'wallet.withdrawalHistory.manualAdjust.adjustTypePlaceholder': 'Chọn loại',
  'wallet.withdrawalHistory.manualAdjust.increaseFlow': 'Tăng doanh thu',
  'wallet.withdrawalHistory.manualAdjust.decreaseFlow': 'Giảm doanh thu',
  'wallet.withdrawalHistory.manualAdjust.amount': 'Số tiền',
  'wallet.withdrawalHistory.manualAdjust.amountPlaceholder': 'Nhập số tiền',
  'wallet.withdrawalHistory.manualAdjust.remark': 'Ghi chú',
  'wallet.withdrawalHistory.manualAdjust.remarkPlaceholder': 'Nhập ghi chú',
  'wallet.withdrawalHistory.manualAdjust.confirm': 'Xác nhận',
  'wallet.withdrawalHistory.manualAdjust.cancel': 'Hủy',
  'wallet.withdrawalHistory.manualAdjust.success': 'Thành công',
  'wallet.withdrawalHistory.manualAdjust.error': 'Thất bại',
  'wallet.withdrawalHistory.flowChange.title': 'Lịch sử doanh thu',
  'wallet.withdrawalHistory.flowChange.operationTime': 'Thời gian',
  'wallet.withdrawalHistory.flowChange.type': 'Loại',
  'wallet.withdrawalHistory.flowChange.totalCompletedFlow': 'Tổng doanh thu',
  'wallet.withdrawalHistory.flowChange.beforeFlow': 'Doanh thu trước',
  'wallet.withdrawalHistory.flowChange.flowChange': 'Thay đổi',
  'wallet.withdrawalHistory.flowChange.afterFlow': 'Doanh thu sau',
  'wallet.withdrawalHistory.flowChange.types.recharge': 'Nạp tiền',
  'wallet.withdrawalHistory.flowChange.types.withdraw': 'Rút tiền',
  'wallet.withdrawalHistory.flowChange.types.bonus': 'Khuyến mãi',
  'wallet.withdrawalHistory.flowChange.types.rebate': 'Hoàn trả',
  'wallet.withdrawalHistory.flowChange.types.manual': 'Thủ công',
  'wallet.withdrawalHistory.flowChange.types.game': 'Game',
  'wallet.withdrawalHistory.flowChange.types.point': 'Điểm',
  'wallet.withdrawalHistory.flowChange.types.unknown': 'Khác',
  'wallet.common.refresh': 'Làm mới',
  'wallet.common.takeBack': 'Lấy về',
  'wallet.common.manualAdjust': 'Điều chỉnh thủ công',
  'wallet.common.confirm': 'Xác nhận',
  'wallet.common.cancel': 'Hủy',
  'wallet.common.success': 'Thành công',
  'wallet.common.error': 'Thất bại',
  'wallet.common.loading': 'Đang tải...',
  'wallet.common.switchTabToLoad': 'Chuyển tab để tải nội dung',
  'wallet.common.searchMember': 'Vui lòng nhập tài khoản thành viên vào ô tìm kiếm',
  'wallet.common.operations': 'Thao tác',
  'wallet.common.takeBackConfirm': 'Bạn có chắc chắn muốn lấy về số dư tài khoản không?',
  'wallet.common.takeBackWarning': 'Sau khi xác nhận sẽ lấy về hàng loạt, vui lòng kiểm tra số dư tài khoản sau.',
  'wallet.withdrawalHistory.flowExceedError': 'Điều chỉnh doanh thu không được vượt quá doanh thu còn lại',
  'member.gameAccountTrade.columns.transId': 'Mã giao dịch',
  'member.gameAccountTrade.columns.platformCode': 'Nền tảng game',
  'member.gameAccountTrade.columns.gameType': 'Loại game',
  'member.gameAccountTrade.columns.gameName': 'Tên game',
  'member.gameAccountTrade.columns.gameCode': 'Mã game',
  'member.gameAccountTrade.columns.eventTime': 'Thời gian cược',
  'member.gameAccountTrade.columns.createTime': 'Thời gian biến động',
  'member.gameAccountTrade.columns.before': 'Số dư trước',
  'member.gameAccountTrade.columns.amount': 'Số tiền',
  'member.gameAccountTrade.columns.balance': 'Số dư sau',
  'member.gameAccountTrade.columns.action': 'API',
  'member.gameAccountTrade.columns.status': 'Trạng thái',
  'member.gameAccountTrade.status.success': 'Thành công',
  'member.gameAccountTrade.status.refund': 'Hoàn tiền',
  'member.gameAccountTrade.search.platformPlaceholder': 'Tất cả nền tảng',
  'member.gameAccountTrade.search.platformAll': 'Tất cả nền tảng',
  'member.gameAccountTrade.search.last7Days': '7 ngày gần nhất',
  'member.gameAccountTrade.search.thisMonth': 'Tháng này',
  'member.gameAccountTrade.gameTypes.1': 'Slot',
  'member.gameAccountTrade.gameTypes.2': 'Live',
  'member.gameAccountTrade.gameTypes.3': 'Thể thao',
  'member.gameAccountTrade.gameTypes.4': 'Xổ số',
  'member.gameAccountTrade.gameTypes.5': 'Bắn cá',
  'member.gameAccountTrade.gameTypes.6': 'Bài',
  'member.gameAccountTrade.gameTypes.7': '3D',
  'member.gameAccountTrade.search.gameType': 'Loại game',
  'member.gameAccountTrade.search.gamePlatform': 'Nền tảng game',
  'member.gameAccountTrade.search.accountChangeTime': 'Thời gian biến động tài khoản',
  'member.gameAccountTrade.search.betTime': 'Thời gian cược',
  'member.gameAccountTrade.search.betStartTime': 'Thời gian bắt đầu cược',
  'member.gameAccountTrade.search.betEndTime': 'Thời gian kết thúc cược',
  'member.gameAccountTrade.validation.betTimeExceedError': 'Phạm vi thời gian cược không được vượt quá phạm vi thời gian biến động tài khoản!',
  'member.gameAccountTrade.error.fetchFailed': 'Lỗi lấy giao dịch tài khoản game:',

  // KycRecordAdd.tsx
  'member.detail.modal.addKyc.title': 'cập nhật KYC',
  'kyc.add.form.basic.information': 'Thông tin cơ bản',
  'kyc.add.form.fullName': 'Họ và tên',
  'kyc.add.form.birth.date': 'Ngày sinh',
  'kyc.add.form.upload.id': 'Tải lên CMND/CCCD của bạn',
  'kyc.add.form.upload.selfie': 'Ảnh tự sướng với CMND/CCCD đã gửi',
  'kyc.add.form.additional.information': 'Thông tin bổ sung',
  'kyc.add.form.birth.place': 'Nơi sinh',
  'kyc.add.form.permanent.address': 'Địa chỉ thường trú',
  'kyc.add.form.current.address': 'Địa chỉ hiện tại',
  'kyc.add.form.nationality': 'Quốc tịch',
  'kyc.add.form.income.source': 'Nguồn thu nhập',
  'kyc.add.form.work.nature': 'Bản chất công việc',
  'kyc.add.form.upload.latest': 'Ảnh mới nhất',
  'member.gameAccountTrade.validation.dateRangeExceedError': 'Phạm vi thời gian biến động tài khoản không được vượt quá 7 ngày!',


  // Trang danh sách thành viên đăng ký không nạp
  'memberNoRecharge.title': 'Danh sách đăng ký không nạp',
  'memberNoRecharge.registerTime': 'Thời gian đăng ký',
  'memberNoRecharge.memberAccount': 'Tài khoản thành viên',
  'memberNoRecharge.memberLevel': 'Cấp thành viên',
  'memberNoRecharge.agentAccount': 'Tài khoản đại lý cấp trên',
  'memberNoRecharge.registerInfo': 'Thông tin đăng ký',
  'memberNoRecharge.registerTimeLabel': 'Thời gian đăng ký',
  'memberNoRecharge.registerIp': 'IP đăng ký',
  'memberNoRecharge.rechargeCount': 'Số lần nạp',
  'memberNoRecharge.withdrawCount': 'Số lần rút',
  'memberNoRecharge.totalRecharge': 'Tổng nạp',
  'memberNoRecharge.totalWithdraw': 'Tổng rút',
  'memberNoRecharge.firstRechargeTime': 'Thời gian nạp đầu',
  'memberNoRecharge.action': 'Hành động',
  'memberNoRecharge.view': 'Xem',
  'memberNoRecharge.query': 'Truy vấn',
  'memberNoRecharge.reset': 'Đặt lại',
  'memberNoRecharge.export': 'Xuất',
  'memberNoRecharge.startDate': 'Ngày bắt đầu',
  'memberNoRecharge.endDate': 'Ngày kết thúc',
  'memberNoRecharge.selectTimeRange': 'Vui lòng chọn phạm vi thời gian hoặc chờ tải dữ liệu',
  'memberNoRecharge.exportingData': 'Đang xuất dữ liệu...',
  'memberNoRecharge.exportSuccess': 'Xuất thành công',
  'memberNoRecharge.exportFailed': 'Xuất thất bại',
  'memberNoRecharge.requestFailed': 'Yêu cầu thất bại',
  'memberNoRecharge.selectTimeRangeRequired': 'Vui lòng chọn phạm vi thời gian đăng ký',

  // Các trường bổ sung trang danh sách thành viên mất khách hàng
  'memberChurn.accountLabel': 'Tài khoản',
  'memberChurn.nameLabel': 'Tên',
  'memberChurn.nicknameLabel': 'Biệt danh',
  'memberChurn.registerTimeLabel': 'Thời gian đăng ký',
  'memberChurn.registerIpLabel': 'IP đăng ký',
  'memberChurn.lastRechargeTimeLabel': 'Thời gian nạp cuối',
  'memberChurn.caliberExplanation.title': 'Mô tả tiêu chuẩn mất khách hàng',
  'memberChurn.caliberExplanation.rule1': 'Hướng dẫn lọc (Thời gian hành vi gần nhất)',
  'memberChurn.caliberExplanation.rule2': '• Có thể lọc riêng lẻ hoặc kết hợp: Nạp gần nhất / Đăng nhập gần nhất / Cược gần nhất (đều là thời gian hành vi "gần nhất" của người dùng).',
  'memberChurn.caliberExplanation.rule3': '• Cách sử dụng thời gian:',
  'memberChurn.caliberExplanation.rule4': '– Chỉ điền "Kết thúc" ⇒ Tìm lần gần nhất ≤ ngày đó;',
  'memberChurn.caliberExplanation.rule5': '– Chỉ điền "Bắt đầu" ⇒ Tìm lần gần nhất ≥ ngày đó (vẫn hoạt động gần đây);',
  'memberChurn.caliberExplanation.rule6': '– Điền "Bắt đầu+Kết thúc" ⇒ Tìm lần gần nhất trong khoảng đó.',
  'memberChurn.caliberExplanation.rule7': 'Ví dụ đơn tiêu chuẩn',
  'memberChurn.caliberExplanation.example1': '– Hôm nay 9/27, nạp kết thúc=9/24 ⇒ Người dùng có nạp gần nhất ≤ 9/24;',
  'memberChurn.caliberExplanation.example2': '– Khoảng đăng nhập 8/1–8/7 ⇒ Người dùng có đăng nhập gần nhất trong 8/1–8/7;',
  'memberChurn.caliberExplanation.example3': '– Cược chỉ điền bắt đầu=9/01 ⇒ Người dùng có cược gần nhất ≥ 9/01.',
  'memberChurn.caliberExplanation.rule8': 'Cách dùng kết hợp (Trả lời các câu hỏi kinh doanh khác nhau)',
  'memberChurn.caliberExplanation.example4': '– Nạp VÀ Đăng nhập: Có quay lại sau nạp không? (VD: lastDep trong tháng 8, lastLogin có vào tháng 9?)',
  'memberChurn.caliberExplanation.example5': '– Nạp VÀ Cược: Có thực sự tiêu dùng sau nạp không? (VD: lastDep mới, nhưng lastBet cũ → chỉ nạp không chơi)',
  'memberChurn.caliberExplanation.example6': '– Đăng nhập VÀ Cược: Có cược khi quay lại không? (VD: lastLogin mới, lastBet cũ → giữ chân truy cập tốt, giữ chân tiêu dùng kém)',
  'memberChurn.caliberExplanation.example7': '– Nạp VÀ Đăng nhập VÀ Cược: Cả ba đều mới = người dùng hoạt động giá trị cao; bất kỳ cái nào cũ = thu hồi có mục tiêu.',
  'memberChurn.lastLoginStartTime': 'Thời gian đăng nhập cuối (Bắt đầu)',
  'memberChurn.lastLoginEndTime': 'Thời gian đăng nhập cuối (Kết thúc)',
  'memberChurn.lastBettingStartTime': 'Thời gian cược cuối (Bắt đầu)',
  'memberChurn.lastBettingEndTime': 'Thời gian cược cuối (Kết thúc)',

  // Danh sách người dùng im lặng
  'memberSilent.title': 'Danh Sách Người Dùng Im Lặng',
  'memberSilent.noDepositDate': 'Ngày Không Nạp Tiền',
  'memberSilent.noDepositDateTip': 'Lần nạp tiền cuối trước ngày này hoặc trống được coi là "người dùng im lặng"',
  'memberSilent.noDepositDateDescription': '"Ngày Không Nạp Tiền" đại diện cho ngày chuẩn; "Im lặng" = lần nạp tiền cuối trước ngày này hoặc trống. Khi "Hôm nay vào im lặng" được chọn: nếu chọn ngày lịch sử, "hôm nay" là ngày đó; để khớp với nhiệm vụ SMS, vui lòng chọn "N ngày gần đây (đến hôm nay)".',
  'memberSilent.selectDate': 'Chọn Ngày',
  'memberSilent.selectNoDepositDate': 'Vui lòng chọn ngày không nạp tiền',
  'memberSilent.selectNoDepositDateRequired': 'Ngày không nạp tiền là bắt buộc',
  'memberSilent.isTodayEnterSilent': 'Hôm Nay Vào Im Lặng',
  'memberSilent.isTodayEnterSilentTip': 'Chọn để chỉ xem người dùng "hôm nay vào im lặng"; nếu chọn ngày lịch sử, "hôm nay" = ngày đó',
  'memberSilent.requireLogin': 'Yêu Cầu Đăng Nhập Trong Khoảng',
  'memberSilent.loginStart': 'Thời Gian Bắt Đầu Đăng Nhập',
  'memberSilent.loginEnd': 'Thời Gian Kết Thúc Đăng Nhập',
  'memberSilent.requireBetting': 'Yêu Cầu Cược Trong Khoảng',
  'memberSilent.bettingStart': 'Thời Gian Bắt Đầu Cược',
  'memberSilent.bettingEnd': 'Thời Gian Kết Thúc Cược',
  'memberSilent.vipLevels': 'Cấp VIP',
  'memberSilent.selectVipLevels': 'Vui lòng chọn cấp VIP',
  'memberSilent.selectAllVip': 'Chọn Tất Cả',
  'memberSilent.excludeOfficialUsers': 'Loại Trừ Người Dùng Chính Thức',
  'memberSilent.excludeAllAgents': 'Loại Trừ Tất Cả Đại Lý',
  'memberSilent.excludeAgentIds': 'Loại Trừ Đại Lý Cụ Thể',
  'memberSilent.selectExcludeAgents': 'Chọn đại lý để loại trừ (có thể tìm kiếm, nhiều lựa chọn)',
  'memberSilent.query': 'Truy Vấn',
  'memberSilent.reset': 'Đặt Lại',
  'memberSilent.export': 'Xuất',
  'memberSilent.exportingData': 'Đang xuất dữ liệu...',
  'memberSilent.exportSuccess': 'Xuất thành công',
  'memberSilent.exportFailed': 'Xuất thất bại',
  'memberSilent.requestFailed': 'Yêu cầu thất bại',
  'memberSilent.lastLoginTime': 'Thời Gian Đăng Nhập Cuối',
  'memberSilent.currencyRequired': 'Vui lòng chọn loại tiền',
  'memberSilent.lastRechargeTime': 'Thời Gian Nạp Tiền Cuối',
  'memberSilent.lastBettingTime': 'Thời Gian Cược Cuối',
  'memberSilent.totalRecharge': 'Tổng Nạp Tiền (Đa Tiền Tệ)',
  'memberSilent.tip': 'Mẹo',
  // Thông tin kiểm soát rủi ro
  'member.detail.riskControl.sameIpUsers': 'Người dùng cùng IP',
  'member.detail.riskControl.sameDeviceUsers': 'Người dùng cùng thiết bị',
  'member.detail.riskControl.sameBankCardUsers': 'Người dùng cùng thẻ ngân hàng',
  'member.detail.riskControl.sameWalletUsers': 'Người dùng cùng ví',
  'member.detail.riskControl.ipAddress': 'Địa chỉ IP',
  'member.detail.riskControl.ipRegion': 'Khu vực IP',
  'member.detail.riskControl.deviceId': 'ID thiết bị',
  'member.detail.riskControl.deviceType': 'Loại thiết bị',
  'member.detail.riskControl.bankAccountName': 'Tên tài khoản ngân hàng',
  'member.detail.riskControl.bankCardNumber': 'Số thẻ ngân hàng',
  'member.detail.riskControl.walletAccount': 'Tài khoản ví',
  'member.detail.riskControl.walletType': 'Loại ví',
  'member.detail.riskControl.associatedAccounts': 'Tài khoản liên kết',
  'member.detail.riskControl.expand': 'Mở rộng',
  'member.detail.riskControl.allAccounts': 'Tất cả tài khoản liên kết',
  'member.detail.riskControl.totalAccounts': 'Tổng số tài khoản',
  'member.detail.riskControl.searchAccount': 'Tìm kiếm tài khoản',
  'member.detail.riskControl.noAccountsFound': 'Không tìm thấy tài khoản',

  // Danh sách mời bạn bè
  'inviterList.title': 'Danh sách mời bạn bè',
  'inviterList.column.chainTime': 'Thời gian thành tuyến',
  'inviterList.column.lastInviteTime': 'Thời gian mời gần nhất',
  'inviterList.column.lineCount': 'Tổng người toàn tuyến',
  'inviterList.column.belongAgent': 'Đại lý trực thuộc',
  'inviterList.agentUnassigned': 'Chưa phân bổ',
  'inviterList.editAgent': 'Sửa',
  'inviterList.agentFilterPlaceholder': 'Tất cả (có thể tìm)',
  'inviterList.topInviter': 'Cấp cao nhất',
  'inviterList.depth.level': 'Bạn bè cấp {{level}}',
  'inviterList.status.valid': 'Hợp lệ',
  'inviterList.status.notQualified': 'Chưa đạt',
  'inviterList.tag.inviteeBlocked': 'Người được mời bị khóa',
  'inviterList.tag.inviterBlocked': 'Người mời bị khóa',
  'inviterList.action.drill': 'Xem cấp dưới',
  'inviterList.action.report': 'Báo cáo',
  'inviterList.filter.account': 'Tài khoản',
  'inviterList.filter.accountPlaceholder': 'Nhập tài khoản người dùng',
  'inviterList.filter.tag': 'Nhãn người dùng',
  'inviterList.filter.currency': 'Loại tiền',
  'inviterList.filter.tagPlaceholder': 'VD: Chuyên viên quảng bá',
  'inviterList.inviter': 'Người mời',
  'inviterList.inviterPlaceholder': 'Vui lòng nhập tài khoản hoặc UID người mời',
  'inviterList.inviteCode': 'Mã mời',
  'inviterList.inviteCodePlaceholder': 'Vui lòng nhập mã mời',
  'inviterList.inviteStatus': 'Trạng thái mời',
  'inviterList.status.all': 'Tất cả',
  'inviterList.status.normal': 'Bình thường',
  'inviterList.status.blacklist': 'Danh sách đen',
  'inviterList.search': 'Tìm kiếm',
  'inviterList.reset': 'Đặt lại',
  'inviterList.export': 'Xuất',
  'inviterList.exporting': 'Đang xuất, vui lòng đợi...',
  'inviterList.exportSuccess': 'Xuất thành công',
  'inviterList.exportFailed': 'Xuất thất bại',
  'inviterList.inviteSettings': 'Cài đặt mời',
  'inviterList.searchHint': 'Vui lòng điền ít nhất một trong số người mời hoặc mã mời.',
  'inviterList.registerTime': 'Thời gian đăng ký',
  'inviterList.inviteCount': 'Số người mời',
  'inviterList.validCount': 'Số người hợp lệ',
  'inviterList.depositUsers': 'Số người nạp tiền',
  'inviterList.metric.inviteCount': 'Số lượng mời',
  'inviterList.metric.validCount': 'Số lượng hợp lệ',
  'inviterList.metric.depositCount': 'Số người nạp tiền',
  'inviterList.metricValue': 'Giá trị',
  'inviterList.action': 'Thao tác',
  'inviterList.detail': 'Chi tiết',
  'inviterList.addBlacklist': 'Thêm vào danh sách đen',
  'inviterList.removeBlacklist': 'Gỡ khỏi danh sách đen',
  'inviterList.total': 'Tổng {count} người mời.',
  'inviterList.uid': 'UID',
  'inviterList.requestFailed': 'Yêu cầu thất bại',
  'inviterList.setting': 'Cài đặt',
  'inviterList.delete': 'Xóa',
  'inviterList.currentStatus': 'Trạng thái hiện tại',
  'inviterList.currencySwitchHint': 'Chuyển đổi tiền tệ sẽ ảnh hưởng đến thống kê và dữ liệu danh sách.',

  // Người được mời
  'inviterList.invitee.title': 'Người dùng được mời',
  'inviterList.invitee.account': 'Tài khoản thành viên',
  'inviterList.invitee.memberId': 'Tài khoản thành viên',
  'inviterList.invitee.memberIdPlaceholder': 'Vui lòng nhập tài khoản thành viên (ID thành viên)',
  'inviterList.invitee.status': 'Trạng thái người được mời',
  'inviterList.invitee.level': 'Cấp',
  'inviterList.invitee.level.1': 'Bạn bè cấp 1',
  'inviterList.invitee.level.2': 'Bạn bè cấp 2',
  'inviterList.invitee.level.3': 'Bạn bè cấp 3',
  'inviterList.invitee.level.n': 'Bạn bè cấp {{level}}',
  'inviterList.inviteeStatus.valid': 'Hợp lệ',
  'inviterList.inviteeStatus.invalid': 'Không hợp lệ',
  'inviterList.inviteeStatus.blacklist': 'Đã đưa vào danh sách đen',
  'inviterList.invitee.registerTime': 'Thời gian đăng ký',
  'inviterList.invitee.effectiveTime': 'Thời gian hiệu lực',
  'inviterList.invitee.firstDepositAmount': 'Số tiền nạp đầu tiên',
  'inviterList.invitee.firstDepositTime': 'Thời gian nạp đầu tiên',
  'inviterList.invitee.totalDeposit': 'Số tiền hợp lệ',
  'inviterList.invitee.totalFlow': 'Dòng chảy hiệu quả',
  'inviterList.invitee.currentStatus': 'Trạng thái hiện tại',
  'inviterList.invitee.timeMode': 'Lựa chọn thời gian',
  'inviterList.invitee.timeMode.none': 'Không',
  'inviterList.invitee.timeMode.register': 'Thời gian đăng ký',
  'inviterList.invitee.timeMode.effective': 'Thời gian hiệu lực',
  'inviterList.invitee.startDate': 'Ngày bắt đầu',
  'inviterList.invitee.endDate': 'Ngày kết thúc',
  'inviterList.invitee.stats.depositUsers': 'Số người hợp lệ',
  'inviterList.invitee.stats.totalDeposit': 'Tổng nạp tiền',
  'inviterList.invitee.stats.totalFlow': 'Dòng chảy hiệu quả',
  'inviterList.invitee.total': 'Tổng {count} người dùng được mời ({currency}).',
  'inviterList.invitee.loadMore': 'Hiển thị thêm (đã hiển thị {{loaded}} / {{total}})',

  // Cài đặt người được mời
  'inviterList.inviteeSetting.title': 'Cài đặt người được mời',
  'inviterList.inviteeSetting.warning': 'Thao tác này sẽ ảnh hưởng đến mối quan hệ mời và phân phối phần thưởng. Vui lòng xác nhận trước khi thực hiện.',
  'inviterList.inviteeSetting.actionType': 'Thao tác có sẵn',
  'inviterList.inviteeSetting.setValid': 'Gỡ khỏi danh sách đen',
  'inviterList.inviteeSetting.setInvalid': 'Đặt vào danh sách đen',
  'inviterList.inviteeSetting.actionHint': 'Đặt là Hợp lệ: Chỉ xác thực ngưỡng nạp tiền và giới hạn thời gian. Đặt là Không hợp lệ: Có hiệu lực ngay lập tức và xóa thời gian hiệu lực.',
  'inviterList.inviteeSetting.reason': 'Lý do thao tác',
  'inviterList.inviteeSetting.reasonPlaceholder': 'Vui lòng nhập lý do thao tác (bắt buộc)',
  'inviterList.inviteeSetting.reasonRequired': 'Lý do thao tác là bắt buộc',
  'inviterList.inviteeSetting.history.title': 'Lịch sử',
  'inviterList.inviteeSetting.history.time': 'Thời gian',
  'inviterList.inviteeSetting.history.action': 'Thao tác',
  'inviterList.inviteeSetting.history.operator': 'Người thao tác',
  'inviterList.inviteeSetting.history.reason': 'Lý do',
  'inviterList.inviteeSetting.history.add': 'Thêm kiểm soát rủi ro',
  'inviterList.inviteeSetting.history.remove': 'Gỡ kiểm soát rủi ro',
  'inviterList.inviteeSetting.success': 'Thao tác thành công',
  'inviterList.inviteeSetting.failed': 'Thao tác thất bại',

  // Danh sách đen
  'inviterList.blacklist.addTitle': 'Thêm vào danh sách đen mời',
  'inviterList.blacklist.removeTitle': 'Gỡ khỏi danh sách đen mời',
  'inviterList.blacklist.warning': 'Thao tác này sẽ ảnh hưởng đến mối quan hệ mời và phân phối phần thưởng. Vui lòng xác nhận trước khi thực hiện.',
  'inviterList.blacklist.reason': 'Lý do thao tác',
  'inviterList.blacklist.reasonPlaceholder': 'Vui lòng nhập lý do thao tác (bắt buộc)',
  'inviterList.blacklist.reasonRequired': 'Lý do thao tác là bắt buộc',
  'inviterList.blacklist.history.title': 'Lịch sử',
  'inviterList.blacklist.history.time': 'Thời gian',
  'inviterList.blacklist.history.action': 'Thao tác',
  'inviterList.blacklist.history.operator': 'Người thao tác',
  'inviterList.blacklist.history.reason': 'Lý do',
  'inviterList.blacklist.history.add': 'Thêm kiểm soát rủi ro',
  'inviterList.blacklist.history.remove': 'Gỡ kiểm soát rủi ro',
  'inviterList.blacklist.addSuccess': 'Đã thêm vào danh sách đen',
  'inviterList.blacklist.removeSuccess': 'Đã gỡ khỏi danh sách đen',
  'inviterList.blacklist.failed': 'Thao tác thất bại',

  // Cài đặt mời
  'inviterList.inviteSettings.title': 'Cài đặt mời',
  'inviterList.inviteSettings.systemStatus': 'Trạng thái chức năng hệ thống',
  'inviterList.inviteSettings.systemStatusHint': 'Chỉ được kiểm soát bởi backend, không hiển thị cho người dùng.',
  'inviterList.inviteSettings.enabled': 'Bật',
  'inviterList.inviteSettings.disabled': 'Tắt',
  'inviterList.inviteSettings.effectiveTime': 'Thời gian hiệu lực',
  'inviterList.inviteSettings.longTerm': 'Dài hạn',
  'inviterList.inviteSettings.timeRange': 'Khoảng thời gian chỉ định',
  'inviterList.inviteSettings.shareDomain': 'Tên miền chính liên kết chia sẻ giao diện người dùng',
  'inviterList.inviteSettings.currencyConfigs': 'Cấu hình tiền tệ (nhiều)',
  'inviterList.inviteSettings.currencyConfigsHint': 'Mỗi loại tiền tệ có "Định nghĩa Người dùng Hợp lệ" riêng (không thể chia sẻ nếu số tiền khác nhau).',
  'inviterList.inviteSettings.addCurrencyConfig': 'Thêm cấu hình tiền tệ',
  'inviterList.inviteSettings.currency': 'Tiền tệ',
  'inviterList.inviteSettings.relatedPromo': 'Ưu đãi liên quan',
  'inviterList.inviteSettings.selectPromo': 'Chọn tên ưu đãi',
  'inviterList.inviteSettings.defaultPromo': 'Mời bạn bè (Mặc định)',
  'inviterList.inviteSettings.depositThreshold': 'Ngưỡng nạp tiền tích lũy',
  'inviterList.inviteSettings.depositFlowThreshold': 'Ngưỡng dòng chảy hiệu quả tích lũy',
  'inviterList.inviteSettings.amount': 'Số tiền',
  'inviterList.inviteSettings.timeLimit': 'Giới hạn thời gian đạt tiêu chuẩn',
  'inviterList.inviteSettings.timeLimit.afterRegister': 'Sau khi đăng ký',
  'inviterList.inviteSettings.timeLimit.inActive': 'Hoàn thành trong thời gian hoạt động',
  'inviterList.inviteSettings.days': 'Ngày',
  'inviterList.inviteSettings.tip': 'Gợi ý',
  'inviterList.inviteSettings.tipContent': '"Đặt là Hợp lệ" chỉ xác thực: ngưỡng nạp tiền và giới hạn thời gian (N ngày sau khi đăng ký / hoàn thành trong thời gian hoạt động).',
  'inviterList.inviteSettings.saveSuccess': 'Lưu thành công',
  'inviterList.inviteSettings.saveFailed': 'Lưu thất bại',
  'inviterList.inviteSettings.duplicateCurrency': 'Tiền tệ {currencies} có cấu hình trùng lặp, mỗi loại tiền tệ chỉ có thể thêm một cấu hình',
  'inviterList.inviteSettings.currencyExists': 'Tiền tệ {currency} đã có cấu hình, mỗi loại tiền tệ chỉ có thể thêm một cấu hình',

  // Hồ sơ nợ xấu
  'member.badDebt.columns.badDebtTime': 'Thời gian nợ xấu',
  'member.badDebt.columns.betOrderNo': 'Số đơn cược',
  'member.badDebt.columns.externalBetOrderNo': 'Số đơn hàng',
  'member.badDebt.columns.gamePlatform': 'Nền tảng game',
  'member.badDebt.columns.gameType': 'Loại game',
  'member.badDebt.columns.betTime': 'Thời gian cược',
  'member.badDebt.columns.settleTime': 'Thời gian thanh toán',
  'member.badDebt.columns.betAmount': 'Số tiền cược',
  'member.badDebt.columns.payoutAmount': 'Số tiền trả thưởng',
  'member.badDebt.columns.badDebtAmount': 'Số tiền nợ xấu (phải thu)',
  'member.badDebt.columns.deductedAmount': 'Số tiền đã khấu trừ (đã thu)',
  'member.badDebt.columns.undeductedAmount': 'Số tiền chưa khấu trừ (chưa thu)',
  'member.badDebt.columns.badDebtStatus': 'Trạng thái nợ xấu',
  'member.badDebt.columns.lastDeductionTime': 'Thời gian khấu trừ cuối',
  'member.badDebt.columns.operation': 'Thao tác',
  'member.badDebt.search.badDebtTime': 'Thời gian nợ xấu',
  'member.badDebt.search.badDebtStatus': 'Trạng thái nợ xấu',
  'member.badDebt.search.gamePlatform': 'Nền tảng game',
  'member.badDebt.search.gameType': 'Loại game',
  'member.badDebt.search.betOrderNo': 'Số đơn cược',
  'member.badDebt.search.externalBetOrderNo': 'Số đơn hàng',
  'member.badDebt.search.externalBetOrderNoPlaceholder': 'Vui lòng nhập số đơn hàng',
  'member.badDebt.search.selectBadDebtStatus': 'Chọn trạng thái nợ xấu',
  'member.badDebt.search.selectGamePlatform': 'Tất cả',
  'member.badDebt.search.selectGameType': 'Tất cả',
  'member.badDebt.search.betOrderNoPlaceholder': 'Vui lòng nhập',
  'member.badDebt.search.query': 'Truy vấn',
  'member.badDebt.search.refresh': 'Làm mới',
  'member.badDebt.search.export': 'Xuất',
  'member.badDebt.status.pending': 'Chờ khấu trừ',
  'member.badDebt.status.partial': 'Khấu trừ một phần',
  'member.badDebt.status.settled': 'Đã thanh toán',
  'member.badDebt.status.writtenOff': 'Đã xóa sổ',
  'member.badDebt.operation.viewDetail': 'Xem chi tiết',
  'member.badDebt.detail.title': 'Chi tiết nợ xấu',
  'member.badDebt.detail.basicInfo': 'Thông tin cơ bản',
  'member.badDebt.detail.memberAccount': 'Tài khoản thành viên',
  'member.badDebt.detail.platformName': 'Tên nền tảng',
  'member.badDebt.detail.currency': 'Loại tiền tệ',
  'member.badDebt.detail.gameName': 'Tên game',
  'member.badDebt.detail.deductionHistory': 'Lịch sử khấu trừ',
  'member.badDebt.detail.deductionTime': 'Thời gian khấu trừ',
  'member.badDebt.detail.badDebtAmount': 'Số tiền nợ xấu',
  'member.badDebt.detail.deductAmount': 'Số tiền khấu trừ',
  'member.badDebt.detail.badDebtStatus': 'Trạng thái nợ xấu',
  'member.badDebt.detail.remark': 'Ghi chú',
  'member.badDebt.writeOff.button': 'Xóa sổ',
  'member.badDebt.writeOff.confirmTitle': 'Xác nhận xóa sổ',
  'member.badDebt.writeOff.confirmContent': 'Bạn có chắc chắn muốn xóa sổ không? Thao tác này không thể hoàn tác.',
  'member.badDebt.writeOff.defaultRemark': 'Xóa sổ thủ công',
  'member.badDebt.message.viewDetailComingSoon': 'Tính năng xem chi tiết đang phát triển',
  'member.badDebt.message.dataPkCodeRequired': 'Mã PK dữ liệu không tồn tại',
  'member.badDebt.message.fetchDetailFailed': 'Không thể lấy chi tiết',
  'member.badDebt.message.writeOffSuccess': 'Xóa sổ thành công',
  'member.badDebt.message.writeOffFailed': 'Xóa sổ thất bại',
  'member.badDebt.error.fetchFailed': 'Không thể lấy dữ liệu nợ xấu',
  'member.badDebt.message.selectMember': 'Vui lòng chọn thành viên trước',
  'member.badDebt.message.exporting': 'Đang xuất...',
  'member.badDebt.message.exportSuccess': 'Xuất thành công',
  'member.badDebt.message.exportFailed': 'Xuất thất bại',
  // Common translations for bad debt detail modal
  'common.cancel': 'Hủy',
  'common.confirm': 'Xác nhận',
  'common.close': 'Đóng',
  'common.loading': 'Đang tải...',
  'common.noData': 'Không có dữ liệu',

  // Trang danh sách thành viên nạp tiền
  'depositMemberList.title': 'Danh sách người dùng nạp tiền',
  'depositMemberList.subtitle': '(Ngoài bộ lọc thời gian, vui lòng điền ít nhất một điều kiện truy vấn)',
  'depositMemberList.searchWarning': 'Vui lòng điền ít nhất một điều kiện truy vấn',
  'depositMemberList.timeRequired': 'Vui lòng chọn phạm vi thời gian',
  'depositMemberList.currencyRequiredForRecharge': 'Vui lòng chọn loại tiền tệ khi lọc theo số lần hoặc số tiền nạp',
  'depositMemberList.currencyRequiredForTimeType': 'Vui lòng chọn loại tiền tệ khi lọc theo thời gian nạp đầu tiên hoặc thời gian nạp gần nhất',
  'depositMemberList.timeType': 'Loại thời gian',
  'depositMemberList.lastRechargeTime': 'Thời gian nạp tiền gần nhất',
  'depositMemberList.firstRechargeTime': 'Thời gian nạp tiền đầu tiên',
  'depositMemberList.registerTime': 'Thời gian đăng ký',
  'depositMemberList.memberAccount': 'Tài khoản thành viên',
  'depositMemberList.memberAccountLabel': 'Tài khoản thành viên',
  'depositMemberList.memberAccountPlaceholder': 'Vui lòng nhập tài khoản thành viên',
  'depositMemberList.realName': 'Tên thật',
  'depositMemberList.realNameLabel': 'Tên thật',
  'depositMemberList.realNamePlaceholder': 'Vui lòng nhập tên thật',
  'depositMemberList.memberNameLabel': 'Tên thành viên',
  'depositMemberList.agentAccount': 'Tài khoản đại lý',
  'depositMemberList.agentAccountPlaceholder': 'Vui lòng nhập tài khoản đại lý',
  'depositMemberList.rechargeCount': 'Số lần nạp tiền',
  'depositMemberList.rechargeCountPlaceholder': 'Vui lòng nhập số lần nạp tiền tối thiểu',
  'depositMemberList.rechargeAmount': 'Số tiền nạp',
  'depositMemberList.rechargeAmountPlaceholder': 'Vui lòng nhập số tiền nạp tối thiểu',
  'depositMemberList.excludeAgent': 'Loại trừ đại lý',
  'depositMemberList.excludeAgentPlaceholder': 'Chọn đại lý để loại trừ (có thể tìm kiếm, chọn nhiều)',
  'depositMemberList.excludeAllAgent': 'Loại trừ tất cả đại lý',
  'depositMemberList.excludeOfficialUser': 'Loại trừ người dùng chính thức',
  'depositMemberList.mobileValid': 'Người dùng đã xác minh số điện thoại',
  'depositMemberList.smsTask': 'Tác vụ SMS liên quan',
  'depositMemberList.smsTaskPlaceholder': 'Chọn tác vụ SMS để lọc',
  'depositMemberList.matchedUsers': 'người dùng khớp',
  'depositMemberList.search': 'Tìm kiếm',
  'depositMemberList.reset': 'Đặt lại',
  'depositMemberList.export': 'Xuất',
  'depositMemberList.vipLevel': 'Cấp độ VIP',
  'depositMemberList.registerInfo': 'Thông tin đăng ký',
  'depositMemberList.registerIp': 'IP đăng ký',
  'depositMemberList.depositCount': 'Số lần nạp tiền',
  'depositMemberList.firstDepositAmount': 'Số tiền nạp lần đầu',
  'depositMemberList.firstDepositTime': 'Thời gian nạp tiền lần đầu',
  'depositMemberList.lastDepositAmount': 'Số tiền nạp gần nhất',
  'depositMemberList.lastDepositTime': 'Thời gian nạp tiền gần nhất',
  'depositMemberList.totalDeposit': 'Tổng nạp',
  'depositMemberList.totalWithdraw': 'Tổng rút',
  'depositMemberList.depositWithdrawDiff': 'Chênh lệch nạp-rút',
  'depositMemberList.action': 'Thao tác',
  'depositMemberList.view': 'Chi tiết',
  // Lịch sử nạp tiền Modal
  'depositMemberList.payOrderHistory.title': 'Lịch sử nạp tiền',
  'depositMemberList.payOrderHistory.fetchError': 'Không thể tải lịch sử nạp tiền',
  'depositMemberList.payOrderHistory.orderNumber': 'Mã đơn hàng',
  'depositMemberList.payOrderHistory.amount': 'Số tiền',
  'depositMemberList.payOrderHistory.paymentMethod': 'Phương thức thanh toán',
  'depositMemberList.payOrderHistory.paymentChannel': 'Kênh thanh toán',
  'depositMemberList.payOrderHistory.createTime': 'Thời gian tạo',
  'depositMemberList.payOrderHistory.successTime': 'Thời gian thành công',
  'depositMemberList.payOrderHistory.status': 'Trạng thái',
  'depositMemberList.payOrderHistory.status.pending': 'Chờ thanh toán',
  'depositMemberList.payOrderHistory.status.paid': 'Đã thanh toán',
  'depositMemberList.payOrderHistory.status.expired': 'Đã hết hạn',
  'depositMemberList.payOrderHistory.status.invalid': 'Không hợp lệ',

  // VIP Member List page
  'vipMemberList.title': 'Danh sách thành viên VIP',
  'vipMemberList.timeRequired': 'Vui lòng chọn phạm vi thời gian',
  'vipMemberList.currencyRequiredForRecharge': 'Vui lòng chọn loại tiền tệ khi lọc theo số lần nạp, số tiền nạp hoặc số lần rút tiền',
  'vipMemberList.currencyRequiredForTimeType': 'Vui lòng chọn loại tiền tệ khi lọc theo thời gian nạp gần nhất',
  'vipMemberList.timeType': 'Loại thời gian',
  'vipMemberList.lastRechargeTime': 'Thời gian nạp cuối',
  'vipMemberList.firstRechargeTime': 'Thời gian nạp đầu',
  'vipMemberList.registerTime': 'Thời gian đăng ký',
  'vipMemberList.memberAccount': 'Tài khoản thành viên',
  'vipMemberList.memberAccountLabel': 'Tài khoản',
  'vipMemberList.memberAccountPlaceholder': 'Vui lòng nhập tài khoản thành viên',
  'vipMemberList.realName': 'Tên thật',
  'vipMemberList.realNameLabel': 'Tên thật',
  'vipMemberList.realNamePlaceholder': 'Vui lòng nhập tên thật',
  'vipMemberList.memberNameLabel': 'Biệt danh',
  'vipMemberList.agentAccount': 'Tài khoản đại lý',
  'vipMemberList.agentAccountPlaceholder': 'Vui lòng nhập tài khoản đại lý',
  'vipMemberList.rechargeCount': 'Số lần nạp',
  'vipMemberList.rechargeCountPlaceholder': 'Vui lòng nhập số lần nạp tối thiểu',
  'vipMemberList.rechargeAmount': 'Số tiền nạp',
  'vipMemberList.rechargeAmountPlaceholder': 'Vui lòng nhập số tiền nạp tối thiểu',
  'vipMemberList.withdrawCountPlaceholder': 'Vui lòng nhập số lần rút tiền tối thiểu',
  'vipMemberList.excludeAgent': 'Loại trừ đại lý',
  'vipMemberList.excludeAgentPlaceholder': 'Chọn đại lý để loại trừ',
  'vipMemberList.excludeAllAgent': 'Loại trừ tất cả đại lý',
  'vipMemberList.excludeOfficialUser': 'Loại trừ người dùng chính thức',
  'vipMemberList.smsTask': 'Nhiệm vụ SMS',
  'vipMemberList.smsTaskPlaceholder': 'Chọn nhiệm vụ SMS để lọc',
  'vipMemberList.search': 'Tìm kiếm',
  'vipMemberList.reset': 'Đặt lại',
  'vipMemberList.export': 'Xuất',
  'vipMemberList.vipLevel': 'Cấp VIP',
  'vipMemberList.registerInfo': 'Thông tin đăng ký',
  'vipMemberList.registerIp': 'IP đăng ký',
  'vipMemberList.lastDepositTime': 'Thời gian nạp cuối',
  'vipMemberList.totalDeposit': 'Tổng nạp',
  'vipMemberList.totalWithdraw': 'Tổng rút',
  'vipMemberList.depositWithdrawDiff': 'Chênh lệch nạp-rút',
  'vipMemberList.totalBetAmount': 'Tổng cược',
  'vipMemberList.totalWinLoss': 'Tổng thắng/thua',
  'vipMemberList.lastBetTime': 'Thời gian cược cuối',
  'vipMemberList.lastLoginTime': 'Lần đăng nhập cuối',
  'vipMemberList.vipLevelTime': 'Thời gian thay đổi VIP',
  'vipMemberList.action': 'Hành động',
  'vipMemberList.view': 'Chi tiết',

  // Truy vấn người dùng phân hạch Jeepney
  'jeepneyUserList.title': 'Truy vấn người dùng phân hạch',
  'jeepneyUserList.timeType': 'Loại thời gian',
  'jeepneyUserList.lastLoginTime': 'Lần đăng nhập cuối',
  'jeepneyUserList.lastAdvanceTime': 'Lần tiến cuối',
  'jeepneyUserList.memberAccount': 'Tài khoản thành viên',
  'jeepneyUserList.memberAccountPlaceholder': 'Nhập tài khoản',
  'jeepneyUserList.accountLabel': 'Tài khoản',
  'jeepneyUserList.memberAccountLabel': 'Tài khoản thành viên',
  'jeepneyUserList.memberRealNameLabel': 'Tên thật thành viên',
  'jeepneyUserList.memberNicknameLabel': 'Biệt danh thành viên',
  'jeepneyUserList.realName': 'Tên thật',
  'jeepneyUserList.realNamePlaceholder': '',
  'jeepneyUserList.realNameLabel': 'Tên',
  'jeepneyUserList.nicknameLabel': 'Biệt danh',
  'jeepneyUserList.vipLevel': 'Cấp VIP',
  'jeepneyUserList.memberLevel': 'Cấp thành viên',
  'jeepneyUserList.currentRound': 'Vòng hiện tại',
  'jeepneyUserList.currentStage': 'Giai đoạn hiện tại',
  'jeepneyUserList.rechargeCount': 'Số lần nạp',
  'jeepneyUserList.rechargeAmount': 'Số tiền nạp',
  'jeepneyUserList.settlementSuccessCount': 'Quyết toán thành công',
  'jeepneyUserList.settlementFailureCount': 'Quyết toán thất bại',
  'jeepneyUserList.inviteCount': 'Số lời mời',
  'jeepneyUserList.validInviteCount': 'Số lời mời hợp lệ',
  'jeepneyUserList.pointsExchangeCount': 'Số lần đổi điểm',
  'jeepneyUserList.currency': 'Tiền tệ',
  'jeepneyUserList.currencyAll': 'Tất cả',
  'jeepneyUserList.distributedAmount': 'Số tiền đã phát',
  'jeepneyUserList.fuelCurrency': 'Nhiên liệu',
  'jeepneyUserList.fuelCurrencyTitle': 'Chi tiết nhiên liệu',
  'jeepneyUserList.viewDetail': 'Xem chi tiết',
  'jeepneyUserList.fuelBalance': 'Số dư nhiên liệu',
  'jeepneyUserList.fuelEarned': 'Nhiên liệu kiếm được',
  'jeepneyUserList.fuelConsumed': 'Nhiên liệu tiêu thụ',
  'jeepneyUserList.fuelConsumedShort': 'Tiêu thụ',
  'jeepneyUserList.fuelEarnedShort': 'Nhận',
  'jeepneyUserList.fuelBalanceShort': 'Số dư',
  'jeepneyUserList.fuelItem': 'Mục',
  'jeepneyUserList.fuelValue': 'Giá trị',
  'jeepneyUserList.fuelDate': 'Ngày',
  'jeepneyUserList.fuelMemberAccount': 'Tài khoản',
  'jeepneyUserList.fuelTransactionType': 'Loại',
  'jeepneyUserList.fuelSourceType': 'Nguồn',
  'jeepneyUserList.fuelSourceTypeLabel': 'Nguồn thưởng',
  'jeepneyUserList.fuelTransactionTypeLabel': 'Loại tiền tệ',
  'jeepneyUserList.fuelAmount': 'Số lượng',
  'jeepneyUserList.fuelBalanceBefore': 'Trước',
  'jeepneyUserList.fuelBalanceAfter': 'Sau',
  'jeepneyUserList.sourceTypeAll': 'Tất cả',
  'jeepneyUserList.sourceTypeStageConsume': 'Tiêu hao vượt ải',
  'jeepneyUserList.sourceTypeRoundClear': 'Xóa khi kết thúc vòng',
  'jeepneyUserList.sourceTypeRecharge': 'Nạp nhiên liệu',
  'jeepneyUserList.sourceTypeInvite': 'Mời nhiên liệu',
  'jeepneyUserList.sourceTypeEntry': 'Thưởng vào cửa',
  'jeepneyUserList.sourceTypeStage': 'Thưởng giai đoạn',
  'jeepneyUserList.sourceTypePointsExchange': 'Đổi điểm',
  'jeepneyUserList.transactionTypeAll': 'Tất cả',
  'jeepneyUserList.transactionTypeIncome': 'Thu nhập',
  'jeepneyUserList.transactionTypeExpense': 'Chi tiêu',
  'jeepneyUserList.cashRewardTotal': 'Thưởng tiền mặt - Tổng',
  'jeepneyUserList.cashRewardDistributed': 'Thưởng tiền mặt - Đã phát',
  'jeepneyUserList.cashRewardDistributedTooltip': 'Chi phí hoạt động thực tế',
  'jeepneyUserList.cashRewardTotalTooltip': 'Tổng tiền thưởng từng trúng, bao gồm phần đã bị xóa do bỏ lượt hoặc kết toán thất bại. Không phải số tiền phải trả.',
  'jeepneyUserList.currentRoundPendingCash': 'Chờ kết toán vòng này',
  'jeepneyUserList.currentRoundPendingCashTooltip': 'Đã trúng trong vòng hiện tại nhưng chưa phát. Chỉ phát khi kết toán thành công; bị xóa nếu bỏ lượt hoặc kết toán thất bại.',
  'jeepneyUserList.totalPointsEarned': 'Tổng điểm kiếm được',
  'jeepneyUserList.totalSpinTicketsEarned': 'Tổng vé quay',
  'jeepneyUserList.returnRate': 'Tỷ lệ hoàn vốn',
  'jeepneyUserList.operation': 'Thao tác',
  'jeepneyUserList.rewardDetail': 'Chi tiết thưởng',
  'jeepneyUserList.search': 'Tìm kiếm',
  'jeepneyUserList.reset': 'Đặt lại',
  'jeepneyUserList.export': 'Xuất',
  'jeepneyUserList.exportLoading': 'Đang xuất dữ liệu...',
  'jeepneyUserList.exportSuccess': 'Xuất thành công',
  'jeepneyUserList.exportFail': 'Xuất thất bại',
  'jeepneyUserList.hourlyUpdate': 'Cập nhật hàng giờ',
  'jeepneyUserList.totalActivityCost': 'Tổng chi phí hoạt động',
  'jeepneyUserList.totalReturnRate': 'Tổng tỷ lệ hoàn vốn',
  // Quản lý nhật ký nhập
  'importLog.title': 'Quản lý nhật ký nhập',
  'importLog.fileName': 'Tên tệp',
  'importLog.fileNamePlaceholder': 'Nhập tên tệp',
  'importLog.createTime': 'Thời gian gửi',
  'importLog.completeTime': 'Thời gian hoàn thành',
  'importLog.totalCount': 'Tổng số',
  'importLog.successCount': 'Thành công',
  'importLog.failCount': 'Thất bại',
  'importLog.status': 'Trạng thái',
  'importLog.statusPending': 'Đang xử lý',
  'importLog.statusComplete': 'Đã hoàn thành',
  'importLog.action': 'Thao tác',
  'importLog.viewDetail': 'Xem chi tiết',
  'importLog.search': 'Tìm kiếm',
  'importLog.reset': 'Đặt lại',
  'importLog.requestFailed': 'Truy vấn thất bại',
  'importLog.detail.title': 'Chi tiết nhập',
  'importLog.detail.close': 'Đóng',
  'importLog.detail.loading': 'Đang tải...',
  'importLog.detail.headerFileName': 'Tên tệp nhập',
  'importLog.detail.headerOperator': 'Người thao tác',
  'importLog.detail.headerCreateTime': 'Thời gian gửi',
  'importLog.detail.headerCompleteTime': 'Thời gian hoàn thành',
  'importLog.detail.headerStatus': 'Trạng thái nhập',
  'importLog.detail.memberAccount': 'Tài khoản thành viên',
  'importLog.detail.memberAccountPlaceholder': 'Tìm tên người dùng thất bại',
  'importLog.detail.failureReason': 'Lý do thất bại',
  'importLog.detail.failureTitle': 'Chi tiết thất bại',
  'importLog.detail.hint': 'Lưu ý: Chỉ giữ lại tài khoản người dùng thất bại trong vòng một tháng',
  'importLog.detail.noFailedRecords': 'Không có bản ghi thất bại',
  'importLog.detail.noRecords': 'Chưa có bản ghi nhập',

  // Trang danh sách thành viên lỗ vốn
  'negativeProfitMember.title': 'Danh sách thành viên lỗ vốn',
  'negativeProfitMember.dateRangeHint': 'Mặc định hôm qua, kết quả truy vấn là tổng hợp dữ liệu cho khoảng thời gian đã chọn (Lịch sử = không bao gồm hôm nay)',
  'negativeProfitMember.hint': '(Ngoài bộ lọc thời gian, phải điền ít nhất một điều kiện truy vấn)',
  'negativeProfitMember.dateRange': 'Ngày thống kê',
  'negativeProfitMember.selectVipLevel': 'Vui lòng chọn cấp VIP',
  'negativeProfitMember.selectAll': 'Chọn tất cả',
  'negativeProfitMember.curDataPkCode': 'Tiền tệ đánh giá',
  'negativeProfitMember.curDataPkCodeRequired': 'Vui lòng chọn tiền tệ đánh giá',
  'negativeProfitMember.selectCurDataPkCode': 'Vui lòng chọn tiền tệ đánh giá',
  'negativeProfitMember.lossThreshold': 'Ngưỡng lỗ ≥',
  'negativeProfitMember.lossThresholdPlaceholder': 'Lỗ ròng tối thiểu 100',
  'negativeProfitMember.memberAccount': 'Tài khoản thành viên',
  'negativeProfitMember.memberAccountPlaceholder': 'Vui lòng nhập tài khoản thành viên',
  'negativeProfitMember.vipLevel': 'Cấp VIP',
  'negativeProfitMember.agentAccount': 'Tài khoản đại lý cấp trên',
  'negativeProfitMember.agentAccountPlaceholder': 'Vui lòng nhập tài khoản đại lý cấp trên',
  'negativeProfitMember.minDepositCount': 'Số lần nạp tiền lịch sử',
  'negativeProfitMember.minDepositCountPlaceholder': 'Vui lòng nhập số lần nạp tiền',
  'negativeProfitMember.minDepositAmount': 'Số tiền nạp lịch sử',
  'negativeProfitMember.minDepositAmountPlaceholder': 'Vui lòng nhập số tiền nạp',
  'negativeProfitMember.minWithdrawCount': 'Số lần rút tiền lịch sử',
  'negativeProfitMember.minWithdrawCountPlaceholder': 'Vui lòng nhập số lần rút tiền',
  'negativeProfitMember.minWithdrawAmount': 'Số tiền rút lịch sử',
  'negativeProfitMember.minWithdrawAmountPlaceholder': 'Vui lòng nhập số tiền rút',
  'negativeProfitMember.loginChannel': 'Thiết bị đăng nhập',
  'negativeProfitMember.selectLoginChannel': 'Vui lòng chọn thiết bị đăng nhập',
  'negativeProfitMember.registerInfo': 'Thông tin đăng ký',
  'negativeProfitMember.registerTime': 'Thời gian đăng ký',
  'negativeProfitMember.registerIp': 'IP đăng ký',
  'negativeProfitMember.realName': 'Tên thật',
  'negativeProfitMember.nickname': 'Biệt danh',
  'negativeProfitMember.depositCount': 'Số lần nạp tiền lịch sử',
  'negativeProfitMember.withdrawCount': 'Số lần rút tiền lịch sử',
  'negativeProfitMember.depositAmount': 'Tổng nạp tiền lịch sử (Đa tiền tệ)',
  'negativeProfitMember.withdrawAmount': 'Tổng rút tiền lịch sử (Đa tiền tệ)',
  'negativeProfitMember.depositWithdrawDiff': 'Chênh lệch nạp/rút lịch sử (Đa tiền tệ)',
  'negativeProfitMember.bettingAmount': 'Tổng cược lịch sử (Đa tiền tệ)',
  'negativeProfitMember.profitLoss': 'Tổng thắng/thua lịch sử (Đa tiền tệ)',
  'negativeProfitMember.totalProfitLoss': 'Tổng thắng/thua tích lũy (Đa tiền tệ)',
  'negativeProfitMember.lastLoginTime': 'Lần đăng nhập cuối',
  'negativeProfitMember.requestFailed': 'Truy vấn thất bại',
  'negativeProfitMember.exportSuccess': 'Xuất thành công',
  'negativeProfitMember.exportFailed': 'Xuất thất bại'
};
